<template>
  <v-layout row wrap>
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false" scrollable>
      <v-card style="background-color: #eeeeee; border-radius: 5px">
        <v-toolbar dark color="primary">
          <!-- <v-tooltip bottom> -->
          <v-btn icon dark @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <span>{{$t('close')}}</span>
          </v-tooltip>-->
          <v-toolbar-title>{{ json_data.save_type == "create" ? $t("menu.EmployeeCreate") : $t("menu.EmployeeEdit") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == "create" ? $t("create") : $t("save") }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4 fixed>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-card style="border-radius: 5px">
                    <v-card-text>
                      <v-flex md12 sm12 xs12>
                        <v-layout row wrap>
                          <v-flex lg2 md2 sm2 xs6 text-xs-center hidden-xs-only>
                            <v-layout row wrap>
                              <v-flex xs12 style="margin-left: 100px; margin-top: 20px">
                                <v-icon @click="cancelimg()">far fa-times-circle</v-icon>
                              </v-flex>
                              <v-flex xs12>
                                <v-avatar size="100" :tile="false" @click="uploadPic()">
                                  <v-icon size="100" color="black" style="cursor: pointer" v-if="img == ''">fas fa-user-circle</v-icon>
                                  <img v-if="img != ''" :src="img" />
                                  <input
                                    type="file"
                                    id="file1"
                                    name="image"
                                    ref="file1"
                                    class="upload"
                                    @change="onChangePicture($event, 1)"
                                    accept="image/*"
                                    capture
                                    style="display: none"
                                  />
                                </v-avatar>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md2 sm2 xs12 text-xs-center hidden-sm-and-up>
                            <v-layout row wrap pa-2 style="margin-bottom: 15px">
                              <v-flex xs12 style="margin-left: 100px; margin-top: 20px">
                                <v-icon @click="cancelimg()">far fa-times-circle</v-icon>
                              </v-flex>
                              <v-flex xs12>
                                <v-avatar size="100" :tile="false" @click="uploadPic()">
                                  <v-icon size="100" color="black" style="cursor: pointer" v-if="img == ''">fas fa-user-circle</v-icon>
                                  <img v-if="img != ''" :src="img" />
                                  <input
                                    type="file"
                                    id="file1"
                                    name="image"
                                    ref="file1"
                                    class="upload"
                                    @change="onChangePicture($event, 1)"
                                    accept="image/*"
                                    capture
                                    style="display: none"
                                  />
                                </v-avatar>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg8 md8 sm8 xs6 text-xs-center hidden-xs-only pa-3>
                            <v-flex xs12 pa-3>
                              <v-layout row warp text-xs-left>
                                <v-flex xs8>
                                  <h2>
                                    {{ $t("name") }} :
                                    {{ form_model.first_name }}
                                    {{ form_model.last_name }}
                                  </h2>
                                </v-flex>
                                <v-flex xs4>
                                  <h2>
                                    {{ $t("nickname") }} :
                                    {{ form_model.nick_name }}
                                  </h2>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 pa-3>
                              <v-layout row warp text-xs-left>
                                <v-flex xs4>
                                  <h2>{{ $t("branch") }} : {{ getBranchName() }}</h2>
                                </v-flex>
                                <v-flex xs4>
                                  <h2>
                                    {{ $t("Department") }} :
                                    {{ selectDepName }}
                                  </h2>
                                </v-flex>
                                <v-flex xs4>
                                  <h2>
                                    {{ $t("Position") }} :
                                    {{ form_model.position }}
                                  </h2>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                  <v-card style="margin-top: 15px; border-radius: 5px">
                    <v-tabs v-model="tabs" pa-3>
                      <v-tabs-slider></v-tabs-slider>
                      <v-tab @click="tabs = 0">
                        <span>{{ $t("EmployeeDetails") }}</span>
                      </v-tab>
                      <v-tab @click="tabs = 1">
                        <span>{{ $t("Workinformation") }}</span>
                      </v-tab>
                      <!-- <v-tab @click="tabs=2">
                            <span>{{$t('TakeLeaveDetails')}}</span>
                          </v-tab> -->
                      <!-- <v-tab @click="tabs = 2">
                        <span>{{ $t("menu.TaxSettingList") }}</span>
                      </v-tab> -->
                    </v-tabs>
                    <v-card-text>
                      <v-tabs-items v-model="tabs">
                        <v-tab-item :value="0">
                          <v-card-text>
                            <v-flex lg12 md12 sm12 xs12>
                              <v-layout row warp pa-3>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex lg12 md12 sm12 xs12 pa-1 style="margin-top: 5px">
                                      <h1 class="text-topic">
                                        {{ $t("EmployeeDetails") }}
                                      </h1>
                                      <v-layout row wrap>
                                        <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'create'">
                                          <v-text-field
                                            :label="$t('employee_code')"
                                            v-model="form_model.code"
                                            :rules="form_rules.code"
                                            @blur="getEmpDetail(form_model)"
                                            append-icon="fas fa-plus-circle"
                                            @click:append="doNewGuid"
                                          />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type != 'create'">
                                          <v-text-field :label="$t('employee_code')" v-model="form_model.code" :rules="form_rules.code" readonly />
                                        </v-flex>

                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field type="number" :label="$t('IDcard')" v-model="form_model.citizen_id" />
                                        </v-flex>

                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('nametitle')" v-model="form_model.name_title" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('name')" v-model="form_model.first_name" :rules="form_rules.first_name" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('lastname')" v-model="form_model.last_name" :rules="form_rules.last_name" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('nickname')" v-model="form_model.nick_name" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('birthday')" v-model="form_model.birth_date" type="date" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <h3>{{ $t("gender") }}</h3>
                                          <v-radio-group v-model="form_model.gender" :column="false">
                                            <v-radio :label="$t('male')" value="male" />
                                            <v-radio :label="$t('female')" value="female" />
                                          </v-radio-group>
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('TelephoneNumber')" v-model="form_model.phone_num" type="phone" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('nationality')" v-model="form_model.nationality" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('race')" v-model="form_model.race" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field label="LINE ID" v-model="form_model.line_id" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('email')" v-model="form_model.email" />
                                        </v-flex>
                                        <v-flex xs12 pa-1>
                                          <v-textarea :label="$t('Address')" v-model="form_model.address" />
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <!-- <v-flex lg6 md6 sm12 xs12 pa-1 style="margin-top:15px;">
                                      <h1 class="text-topic">{{$t('loginpanel')}}</h1>
                                      <v-flex md12 sm12 xs12 px-2>
                                        <v-layout row wrap>
                                          <v-flex md6 sm6 xs12 pa-1>
                                            <v-text-field
                                              v-if="form_model.user_name == '' || form_model.user_name == 'null'"
                                              :label="$t('user_name')"
                                              v-model="user_name2"
                                              :rules="form_rules.username"
                                              @blur="checkUser(user_name2)"
                                              
                                            />
                                            <v-text-field
                                              v-else
                                              :label="$t('user_name')"
                                              v-model="form_model.user_name"
                                              readonly
                                            />
                                          </v-flex>
                                          <v-flex md6 sm6 xs12 pa-1>
                                            <v-text-field
                                              :label="$t('password')"
                                              v-model="form_model.user_password"
                                              :rules="form_rules.password"
                                             
                                            />
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                    </v-flex>-->
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-card-text>
                        </v-tab-item>
                        <v-tab-item :value="1">
                          <v-card-text>
                            <v-flex lg12 md12 sm12 xs12>
                              <v-layout row warp pa-3>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex lg12 md12 sm12 xs12 pa-1 style="margin-top: 5px">
                                      <h1 class="text-topic">
                                        {{ $t("Workinformation") }}
                                      </h1>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap>
                                    <v-flex md4 sm6 xs12 pa-1>
                                      <h3>{{ $t("status") }}</h3>
                                      <v-layout row wrap>
                                        <v-flex md12 sm12 xs12>
                                          <v-radio-group v-model="form_model.status" :column="false">
                                            <v-radio :label="$t('apprentice')" value="0" />
                                            <v-radio :label="$t('placement')" value="1" />
                                            <v-radio :label="$t('suspended')" value="2" />
                                          </v-radio-group>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex md8 sm8 xs12>
                                      <br />
                                      <v-layout row wrap pa-1>
                                        <!-- <v-flex md6 sm6 xs12>
                                          <v-checkbox
                                            :label="
                                              $t('NotusingTimeAttendancesystem')
                                            "
                                            value="1"
                                            v-model="form_model.not_cal_time"
                                          />
                                        </v-flex> -->
                                        <v-flex md6 sm6 xs12 v-show="timeattendance != 0">
                                          <v-checkbox :label="$t('Donotcalculateworkdays')" value="1" v-model="form_model.is_special" />
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex md4 sm4 xs12 pa-1>
                                      <v-select
                                        required
                                        :items="branch_items"
                                        :label="$t('branch')"
                                        item-text="name"
                                        item-value="code"
                                        v-model="form_model.branch"
                                        @input="getProfileDepartmentList()"
                                      />
                                    </v-flex>
                                    <v-flex md4 sm4 xs12 pa-1>
                                      <v-select :items="department_items" :label="$t('Department')" item-text="name" item-value="code" v-model="form_model.department" />
                                    </v-flex>
                                    <v-flex md4 sm4 xs12 pa-1>
                                      <v-text-field :label="$t('Position')" v-model="form_model.position" />
                                    </v-flex>
                                    <v-flex md4 sm4 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('startworkdate')"
                                        v-model="form_model.start_work_date"
                                        type="date"
                                        @blur="formatdate(form_model.start_work_date)"
                                        :rules="form_rules.start_work_date"
                                      />
                                    </v-flex>
                                    <v-flex md4 sm4 xs12 pa-1 v-show="timeattendance != 0">
                                      <v-text-field
                                        :label="$t('Calculatehours')"
                                        type="number"
                                        v-model="form_model.calworkhour"
                                        required
                                        :min="0"
                                        @change="form_model.calworkhour = Math.max(Math.abs(form_model.calworkhour), 0)"
                                      />
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap>
                                    <v-flex md12 sm12 xs12 pa-1>
                                      <!-- <h3>{{ $t("IncomeType") }}</h3> -->
                                      <v-layout row wrap>
                                        <!-- <v-flex md12 sm12 xs12>
                                          <v-radio-group v-model="form_model.emp_type" :column="false">
                                            <v-radio :label="$t('monthly')" value="0" />
                                            <v-radio :label="$t('Daily')" value="1" />
                                            <v-radio :label="$t('Hourly')" value="2" />
                                          </v-radio-group>
                                        </v-flex> -->
                                        <v-flex md12 sm12 xs12>
                                          <v-layout row wrap v-show="form_model.emp_type == '0'">
                                            <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'create'">
                                              <v-text-field
                                                :label="$t('Salary')"
                                                type="number"
                                                v-model="form_model.start_salary"
                                                :min="0"
                                                @change="form_model.start_salary = Math.max(Math.abs(form_model.start_salary), 0)"
                                              />
                                            </v-flex>
                                            <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'update'">
                                              <v-text-field :label="$t('Salary')" type="number" v-model="form_model.start_salary" readonly @click="Salarydialog = true" />
                                            </v-flex>
                                            <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'update'">
                                              <v-text-field :label="$t('CurrentSalary')" type="number" v-model="form_model.current_salary" readonly />
                                            </v-flex>
                                          </v-layout>
                                          <v-layout row wrap v-show="form_model.emp_type == '1'">
                                            <v-flex md12 sm12 xs12 mt-3>
                                              <v-layout row wrap>
                                                <v-flex md12 sm12 xs12>
                                                  <v-radio-group v-model="form_model.earning_daytype" :column="false">
                                                    <v-radio :label="$t('standard')" value="0" />
                                                    <v-radio :label="$t('Daily')" value="1" />
                                                  </v-radio-group>
                                                </v-flex>
                                                <v-flex md12 sm12 xs12>
                                                  <v-layout row wrap v-show="form_model.earning_daytype == '0'">
                                                    <v-flex xs6>
                                                      <v-text-field
                                                        :label="$t('dailyearnings')"
                                                        v-model="form_model.daily_earnings"
                                                        type="number"
                                                        :min="0"
                                                        @change="form_model.daily_earnings = Math.max(Math.abs(form_model.daily_earnings), 0)"
                                                      />
                                                    </v-flex>
                                                  </v-layout>
                                                  <v-layout row wrap v-show="form_model.earning_daytype == '1'">
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Monday')"
                                                        type="number"
                                                        v-model="form_model.daily_monday"
                                                        :min="0"
                                                        @change="form_model.daily_monday = Math.max(Math.abs(form_model.daily_monday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Tuesday')"
                                                        type="number"
                                                        v-model="form_model.daily_tuesday"
                                                        :min="0"
                                                        @change="form_model.daily_tuesday = Math.max(Math.abs(form_model.daily_tuesday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Wednesday')"
                                                        type="number"
                                                        v-model="form_model.daily_wednesday"
                                                        :min="0"
                                                        @change="form_model.daily_wednesday = Math.max(Math.abs(form_model.daily_wednesday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Thursday')"
                                                        type="number"
                                                        v-model="form_model.daily_thursday"
                                                        :min="0"
                                                        @change="form_model.daily_thursday = Math.max(Math.abs(form_model.daily_thursday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Friday')"
                                                        type="number"
                                                        v-model="form_model.daily_friday"
                                                        :min="0"
                                                        @change="form_model.daily_friday = Math.max(Math.abs(form_model.daily_friday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Saturday')"
                                                        type="number"
                                                        v-model="form_model.daily_saturday"
                                                        :min="0"
                                                        @change="form_model.daily_saturday = Math.max(Math.abs(form_model.daily_saturday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Sunday')"
                                                        type="number"
                                                        v-model="form_model.daily_sunday"
                                                        :min="0"
                                                        @change="form_model.daily_sunday = Math.max(Math.abs(form_model.daily_sunday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Specialholiday')"
                                                        type="number"
                                                        v-model="form_model.daily_holiday"
                                                        :min="0"
                                                        @change="form_model.daily_holiday = Math.max(Math.abs(form_model.daily_holiday), 0)"
                                                      />
                                                    </v-flex>
                                                  </v-layout>
                                                </v-flex>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-layout row wrap v-show="form_model.emp_type == '2'">
                                            <v-flex md12 sm12 xs12 mt-3>
                                              <v-layout row wrap>
                                                <v-flex md12 sm12 xs12>
                                                  <v-radio-group v-model="form_model.earning_hourtype" :column="false">
                                                    <v-radio :label="$t('standard')" value="0" />
                                                    <v-radio :label="$t('Daily')" value="1" />
                                                    <v-radio :label="$t('Packages')" value="2" />
                                                  </v-radio-group>
                                                </v-flex>
                                                <v-flex md12 sm12 xs12>
                                                  <v-layout row wrap v-show="form_model.earning_hourtype == '0'">
                                                    <v-flex md6 sm12 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('hourlyearnings')"
                                                        type="number"
                                                        v-model="form_model.hourly_earnings"
                                                        :min="0"
                                                        @change="form_model.hourly_earnings = Math.max(Math.abs(form_model.hourly_earnings), 0)"
                                                      />
                                                    </v-flex>
                                                  </v-layout>
                                                  <v-layout row wrap v-show="form_model.earning_hourtype == '1'">
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Monday')"
                                                        type="number"
                                                        v-model="form_model.hour_monday"
                                                        :min="0"
                                                        @change="form_model.hour_monday = Math.max(Math.abs(form_model.hour_monday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Tuesday')"
                                                        type="number"
                                                        v-model="form_model.hour_tuesday"
                                                        :min="0"
                                                        @change="form_model.hour_tuesday = Math.max(Math.abs(form_model.hour_tuesday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Wednesday')"
                                                        type="number"
                                                        v-model="form_model.hour_wednesday"
                                                        :min="0"
                                                        @change="form_model.hour_wednesday = Math.max(Math.abs(form_model.hour_wednesday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Thursday')"
                                                        type="number"
                                                        v-model="form_model.hour_thursday"
                                                        :min="0"
                                                        @change="form_model.hour_thursday = Math.max(Math.abs(form_model.hour_thursday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Friday')"
                                                        type="number"
                                                        v-model="form_model.hour_friday"
                                                        :min="0"
                                                        @change="form_model.hour_friday = Math.max(Math.abs(form_model.hour_friday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Saturday')"
                                                        type="number"
                                                        v-model="form_model.hour_saturday"
                                                        :min="0"
                                                        @change="form_model.hour_saturday = Math.max(Math.abs(form_model.hour_saturday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Sunday')"
                                                        type="number"
                                                        v-model="form_model.hour_sunday"
                                                        :min="0"
                                                        @change="form_model.hour_sunday = Math.max(Math.abs(form_model.hour_sunday), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md4 sm6 xs12 pa-1>
                                                      <v-text-field
                                                        :label="$t('Specialholiday')"
                                                        type="number"
                                                        v-model="form_model.hour_holiday"
                                                        :min="0"
                                                        @change="form_model.hour_holiday = Math.max(Math.abs(form_model.hour_holiday), 0)"
                                                      />
                                                    </v-flex>
                                                  </v-layout>
                                                  <v-layout row wrap v-show="form_model.earning_hourtype == '2'">
                                                    <v-flex md3 sm3 xs5>
                                                      <v-text-field
                                                        :label="$t('Fromtheamount')"
                                                        v-model="form_model.form_hour_1"
                                                        type="number"
                                                        :min="0"
                                                        @change="form_model.form_hour_1 = Math.max(Math.abs(form_model.form_hour_1), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md1 sm1 xs2 text-xs-center style="padding-top: 18px">
                                                      <h3>-</h3>
                                                    </v-flex>
                                                    <v-flex md3 sm3 xs5>
                                                      <v-text-field
                                                        :label="$t('Toamount')"
                                                        type="number"
                                                        v-model="form_model.to_hour_1"
                                                        :min="0"
                                                        @change="form_model.to_hour_1 = Math.max(Math.abs(form_model.to_hour_1), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md1 sm1 xs1 text-xs-center style="padding-top: 18px">
                                                      <h3>=</h3>
                                                    </v-flex>
                                                    <v-flex md3 sm3 xs12>
                                                      <v-text-field
                                                        :label="$t('menu.IncomeList')"
                                                        type="number"
                                                        v-model="form_model.hourearning_1"
                                                        :min="0"
                                                        @change="form_model.hourearning_1 = Math.max(Math.abs(form_model.hourearning_1), 0)"
                                                      />/>
                                                    </v-flex>
                                                  </v-layout>
                                                  <v-layout row wrap v-show="form_model.earning_hourtype == '2'">
                                                    <v-flex md3 sm3 xs5>
                                                      <v-text-field
                                                        :label="$t('Fromtheamount')"
                                                        v-model="form_model.form_hour_2"
                                                        type="number"
                                                        :min="0"
                                                        @change="form_model.form_hour_2 = Math.max(Math.abs(form_model.form_hour_2), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md1 sm1 xs2 text-xs-center style="padding-top: 18px">
                                                      <h3>-</h3>
                                                    </v-flex>
                                                    <v-flex md3 sm3 xs5>
                                                      <v-text-field
                                                        :label="$t('Toamount')"
                                                        type="number"
                                                        v-model="form_model.to_hour_2"
                                                        :min="0"
                                                        @change="form_model.to_hour_2 = Math.max(Math.abs(form_model.to_hour_2), 0)"
                                                      />
                                                    </v-flex>
                                                    <v-flex md1 sm1 xs12 text-xs-center style="padding-top: 18px">
                                                      <h3>=</h3>
                                                    </v-flex>
                                                    <v-flex md3 sm3 xs12>
                                                      <v-text-field
                                                        :label="$t('menu.IncomeList')"
                                                        type="number"
                                                        v-model="form_model.hourearning_2"
                                                        :min="0"
                                                        @change="form_model.hourearning_2 = Math.max(Math.abs(form_model.hourearning_2), 0)"
                                                      />
                                                    </v-flex>
                                                  </v-layout>
                                                </v-flex>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap>
                                    <v-flex md12 sm12 xs12 pa-1>
                                      <h3>{{ $t("Otherextraincome") }}</h3>
                                      <v-layout row wrap px-2 v-for="(item, index) in form_model.other_income_detail" :key="index">
                                       <v-flex md1 pa-3 >
                                        <v-icon style="margin-top: 5px;margin-right:0px" color="error" @click="removeOtherIncome(index)">delete</v-icon>
                                       </v-flex>
                                        <v-flex md4 sm4 xs12 pa-1 >
                                          <v-text-field label="ชื่อ" v-model="item.name" />
                                        </v-flex>
                                        <v-flex md4 sm4 xs12 pa-1 >
                                          <v-text-field label="จำนวน" v-model="item.value" />
                                        </v-flex>
                                        <v-flex md3 sm4 xs12 pt-3>
                                          <v-checkbox label="รวมรายได้ในประกันสังคม" :value="1" v-model="item.cal_ss" />
                                        </v-flex>
                                      </v-layout>
                                      <v-btn color="info"  @click="addOtherIncome"><v-icon>add</v-icon> เพิ่มรายได้อื่นๆ</v-btn>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap pa-1 v-show="timeattendance != 0">
                                    <v-flex md6 sm6 xs12 px-2 pt-3>
                                      <h3>{{ $t("menu.HolidayList") }}</h3>
                                      <v-select
                                        required
                                        :items="holidayProfile"
                                        :label="$t('menu.HolidayList')"
                                        v-model="form_model.holiday_profile"
                                        item-text="name"
                                        item-value="code"
                                      />
                                      <v-layout row wrap>
                                        <v-flex xs12>
                                          <h3>{{ $t("Leaveyear") }}</h3>
                                          <v-select v-model="leave_year" :items="items" :rules="form_rules.leave_id"></v-select>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 px-2 pt-3>
                                      <h3>{{ $t("Weeklyholiday") }}</h3>
                                      <v-layout row wrap px-2>
                                        <v-flex md4 sm6 xs12>
                                          <v-checkbox :label="$t('Monday')" v-model="weekend_mon" value="1" />
                                        </v-flex>
                                        <v-flex md4 sm6 xs12>
                                          <v-checkbox :label="$t('Tuesday')" v-model="weekend_tue" value="1" />
                                        </v-flex>
                                        <v-flex md4 sm6 xs12>
                                          <v-checkbox :label="$t('Wednesday')" v-model="weekend_wed" value="1" />
                                        </v-flex>
                                        <v-flex md4 sm6 xs12>
                                          <v-checkbox :label="$t('Thursday')" v-model="weekend_thu" value="1" />
                                        </v-flex>
                                        <v-flex md4 sm6 xs12>
                                          <v-checkbox :label="$t('Friday')" v-model="weekend_fri" value="1" />
                                        </v-flex>
                                        <v-flex md4 sm6 xs12>
                                          <v-checkbox :label="$t('Saturday')" v-model="weekend_sat" value="1" />
                                        </v-flex>
                                        <v-flex md4 sm6 xs12>
                                          <v-checkbox :label="$t('Sunday')" v-model="weekend_sun" value="1" />
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 px-2>
                                      <v-select
                                        required
                                        :items="profilePlan"
                                        :label="$t('menu.WorkPlanList')"
                                        v-model="form_model.shift_profile"
                                        item-text="name"
                                        item-value="code"
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 px-2>
                                      <v-select
                                        required
                                        :items="profileConditions"
                                        :label="$t('menu.ConditionsList')"
                                        v-model="form_model.conditions_profile"
                                        item-text="name"
                                        item-value="code"
                                      />
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap>
                                    <v-flex md12 sm12 xs12 pa-1>
                                      <h3>{{ $t("listDeductions") }}</h3>
                                      <v-layout row wrap>
                                        <v-flex md4 sm4 xs12 pa-1>
                                          <v-checkbox :label="$t('Notusesocialsecuritypaymentsystem')" value="1" v-model="form_model.is_auto_ss" />
                                        </v-flex>
                                        <v-flex md8 sm8 xs12 pa-1>
                                          <v-checkbox :label="$t('Notusetaxcalculationsystem')" value="1" v-model="form_model.is_auto_tax" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field
                                            :label="$t('SocialSecurity')"
                                            v-model="form_model.deduct_ss"
                                            type="number"
                                            :min="0"
                                            @change="form_model.deduct_ss = Math.max(Math.abs(form_model.deduct_ss), 0)"
                                          />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field
                                            :label="$t('deducttax')"
                                            v-model="form_model.deduct_tax"
                                            type="number"
                                            :min="0"
                                            @change="form_model.deduct_tax = Math.max(Math.abs(form_model.deduct_tax), 0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                        
                                  <v-layout row wrap>
                                    <v-flex md12 sm12 xs12 pa-1>
                                      <h3>
                                        {{ $t("Bankaccountinformation") }}
                                      </h3>
                                      <v-layout row wrap>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-select required :items="pay_items" :label="$t('PaymentType')" v-model="form_model.payment_type" item-text="name" item-value="code" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('Bank')" v-model="form_model.book_bank" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('Bankaccount')" v-model="form_model.bank_code" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('AccountName')" v-model="form_model.bank_name" />
                                        </v-flex>
                                        <v-flex md6 sm6 xs12 pa-1>
                                          <v-text-field :label="$t('Prompay')" v-model="form_model.promptpay_number" />
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-card-text>
                        </v-tab-item>
                        <!-- <v-tab-item :value="3">
                          <v-card-text>
                            <v-flex lg12 md12 sm12 xs12>
                              <v-layout row warp pa-3>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex lg12 md12 sm12 xs12 pa-1 style="margin-top:5px;">
                                      <h1 class="text-topic">{{$t('TakeLeaveDetails')}}</h1>
                                      <v-layout row wrap>
                                        <v-flex
                                          lg1
                                          md2
                                          sm3
                                          xs12
                                          offset-lg1
                                          style="margin-top:30px;"
                                        >
                                          <strong style="margin-left:5px;">{{$t('Leaveyear')}}</strong>
                                        </v-flex>

                                       <v-flex md4 sm4 xs12 pa-1>
                                      <v-select
                                        required
                                        :items="years_items"
                                        :label="$t('Leaveyear')"
                                        item-text="year_leave"
                                        item-value="year_leave"
                                        v-model="leaveYear"
                                        
                                      />
                                    </v-flex>
                                     
                                      </v-layout>
                                      
                                      <v-layout row wrap>
                                        <v-flex
                                          lg1
                                          md2
                                          sm3
                                          xs12
                                          offset-lg1
                                          style="margin-top:30px;"
                                        >
                                          <strong style="margin-left:5px;">{{$t('Personalleave')}}</strong>
                                        </v-flex>

                                        <v-flex lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Day')"
                                            v-model="form_model.personal_leave_day"
                                            :min="0"
                                            @change="form_model.personal_leave_day = Math.max(Math.abs(form_model.personal_leave_day),0)"
                                          />
                                        </v-flex>
                                        <v-flex offset-lg1 lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Hour')"
                                            v-model="form_model.personal_leave_hour"
                                            :min="0"
                                            @change="form_model.personal_leave_hour = Math.max(Math.abs(form_model.personal_leave_hour),0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                      <v-layout row wrap>
                                        <v-flex
                                          lg1
                                          md2
                                          sm3
                                          xs12
                                          offset-lg1
                                          style="margin-top:30px;"
                                        >
                                          <strong style="margin-left:5px;">{{$t('Sickleave')}}</strong>
                                        </v-flex>
                                        <v-flex lg2 md4 sm4 xs21 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Day')"
                                            v-model="form_model.sick_leave_day"
                                            :min="0"
                                            @change="form_model.sick_leave_day = Math.max(Math.abs(form_model.sick_leave_day),0)"
                                          />
                                        </v-flex>
                                        <v-flex offset-lg1 lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Hour')"
                                            v-model="form_model.sick_leave_hour"
                                            :min="0"
                                            @change="form_model.sick_leave_hour = Math.max(Math.abs(form_model.sick_leave_hour),0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                      <v-layout row wrap>
                                        <v-flex
                                          lg1
                                          md2
                                          sm3
                                          xs12
                                          offset-lg1
                                          style="margin-top:30px;"
                                        >
                                          <strong style="margin-left:5px;">{{$t('Vacationleave')}}</strong>
                                        </v-flex>
                                        <v-flex lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Day')"
                                            v-model="form_model.vacation_leave_day"
                                            :min="0"
                                            @change="form_model.vacation_leave_day = Math.max(Math.abs(form_model.vacation_leave_day),0)"
                                          />
                                        </v-flex>
                                        <v-flex offset-lg1 lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Hour')"
                                            v-model="form_model.vacation_leave_hour"
                                            :min="0"
                                            @change="form_model.vacation_leave_hour = Math.max(Math.abs(form_model.vacation_leave_hour),0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                      <v-layout row wrap>
                                        <v-flex
                                          lg1
                                          md2
                                          sm3
                                          xs12
                                          offset-lg1
                                          style="margin-top:30px;"
                                        >
                                          <strong style="margin-left:5px;">{{$t('Ordinationleave')}}</strong>
                                        </v-flex>
                                        <v-flex lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Day')"
                                            v-model="form_model.ordination_leave_day"
                                            :min="0"
                                            @change="form_model.ordination_leave_day = Math.max(Math.abs(form_model.ordination_leave_day),0)"
                                          />
                                        </v-flex>
                                        <v-flex offset-lg1 lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Hour')"
                                            v-model="form_model.ordination_leave_hour"
                                            :min="0"
                                            @change="form_model.ordination_leave_hour = Math.max(Math.abs(form_model.ordination_leave_hour),0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                      <v-layout row wrap>
                                        <v-flex
                                          lg1
                                          md2
                                          sm3
                                          xs12
                                          offset-lg1
                                          style="margin-top:30px;"
                                        >
                                          <strong style="margin-left:5px;">{{$t('Maternityleave')}}</strong>
                                        </v-flex>
                                        <v-flex lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Day')"
                                            v-model="form_model.maternity_leave_day"
                                            :min="0"
                                            @change="form_model.maternity_leave_day = Math.max(Math.abs(form_model.maternity_leave_day),0)"
                                          />
                                        </v-flex>
                                        <v-flex offset-lg1 lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Hour')"
                                            v-model="form_model.maternity_leave_hour"
                                            :min="0"
                                            @change="form_model.maternity_leave_hour = Math.max(Math.abs(form_model.maternity_leave_hour),0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                      <v-layout row wrap>
                                        <v-flex
                                          lg1
                                          md2
                                          sm3
                                          xs12
                                          offset-lg1
                                          style="margin-top:30px;"
                                        >
                                          <strong
                                            style="margin-left:5px;"
                                          >{{$t('MilitaryServiceLeave')}}</strong>
                                        </v-flex>
                                        <v-flex lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Day')"
                                            v-model="form_model.military_service_leave_day"
                                            :min="0"
                                            @change="form_model.military_service_leave_day = Math.max(Math.abs(form_model.military_service_leave_day),0)"
                                          />
                                        </v-flex>
                                        <v-flex offset-lg1 lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Hour')"
                                            v-model="form_model.military_service_leave_hour"
                                            :min="0"
                                            @change="form_model.military_service_leave_hour = Math.max(Math.abs(form_model.military_service_leave_hour),0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                      <v-layout row wrap>
                                        <v-flex
                                          lg1
                                          md2
                                          sm3
                                          xs12
                                          offset-lg1
                                          style="margin-top:30px;"
                                        >
                                          <strong
                                            style="margin-left:5px;"
                                          >{{$t('Otherleave')}}</strong>
                                        </v-flex>
                                        <v-flex lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Day')"
                                            v-model="form_model.other_leave_day"
                                            :min="0"
                                            @change="form_model.other_leave_day = Math.max(Math.abs(form_model.other_leave_day),0)"
                                          />
                                        </v-flex>
                                        <v-flex offset-lg1 lg2 md4 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('Hour')"
                                            v-model="form_model.other_leave_hour"
                                            :min="0"
                                            @change="form_model.other_leave_hour = Math.max(Math.abs(form_model.other_leave_hour),0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-card-text>
                        </v-tab-item> -->
                        <v-tab-item :value="2">
                          <v-card-text>
                            <v-flex lg12 md12 sm12 xs12>
                              <v-layout row warp pa-3>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex lg12 md12 sm12 xs12 pa-1 style="margin-top: 5px">
                                      <h1 class="text-topic">
                                        {{ $t("menu.TaxSettingList") }}
                                      </h1>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap>
                                    <v-flex md4 sm4 xs12 pa-1>
                                      <v-select
                                        required
                                        :items="years_items"
                                        :label="$t('Year_tax')"
                                        item-text="year_tax"
                                        item-value="year_tax"
                                        v-model="taxYear"
                                        @input="saveyear(taxYear)"
                                      />
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row warp v-if="Taxshow">
                                    <v-flex xs12>
                                      <v-layout row wrap>
                                        <v-flex lg1 md3 sm3 xs6 pa-1 offset-md1>
                                          <h3>
                                            <strong>{{ $t("Otherincome") }}</strong>
                                          </h3>
                                        </v-flex>
                                        <!-- <v-flex lg2 md3 sm3 xs6 pa-2  >
                                          <span>{{income_max}}</span>
                                        </v-flex>-->
                                        <v-flex md2 sm4 xs12 pa-1>
                                          <v-text-field
                                            type="number"
                                            :label="$t('base')"
                                            v-model="income_value"
                                            :min="0"
                                            @change="income_value = Math.max(Math.abs(income_value), 0)"
                                          />
                                        </v-flex>
                                      </v-layout>
                                      <v-flex lg12 md12 sm12 xs12 pa-1 offset-md1>
                                        <h3>
                                          <strong>{{ $t("Deductible") }}</strong>
                                        </h3>
                                      </v-flex>
                                      <v-layout row wrap v-for="(tax_item, index) in tax_details" :key="index">
                                        <v-layout row wrap v-if="tax_item.type == 0">
                                          <v-flex md2 sm3 xs6 pa-1 offset-md2 v-if="tax_item.percent != 0" style="margin-bottom: 30px">
                                            <span>
                                              <strong>{{ $t("Lessexpenses") }}{{ $t("Rate") }}</strong>
                                            </span>
                                          </v-flex>
                                          <v-flex md1 sm2 xs6 pa-1 v-if="tax_item.percent != 0">
                                            <span>{{ tax_item.percent }}</span>
                                          </v-flex>
                                          <v-flex md3 sm5 xs12 pa-1 offset-md2 v-if="tax_item.percent == 0">
                                            <span v-if="tax_item.percent == 0">
                                              <strong>{{ $t(tax_item.name) }}</strong>
                                              <!-- <strong>{{tax_item.name}}</strong> -->
                                            </span>
                                          </v-flex>
                                          <v-flex md2 sm2 xs6 pa-1 v-if="tax_item.percent != 0" style="margin-bottom: 30px">
                                            <span>
                                              <strong>{{ $t("max_value") }}</strong>
                                            </span>
                                          </v-flex>
                                          <v-flex md2 sm2 xs6 pa-1 v-if="tax_item.percent == 0">
                                            <span>
                                              <strong>{{ $t("max_value") }}</strong>
                                            </span>
                                          </v-flex>
                                          <v-flex md1 sm2 xs3 pa-1 v-if="tax_item.percent != 0" style="margin-bottom: 30px">
                                            <span>{{ tax_item.max }}</span>
                                          </v-flex>
                                          <v-flex md1 sm2 xs3 pa-1 v-if="tax_item.percent == 0">
                                            <span>{{ tax_item.max }}</span>
                                          </v-flex>
                                          <v-flex md1 sm1 xs3 pa-1 v-if="tax_item.percent != 0" style="margin-bottom: 30px">
                                            <span>
                                              <strong>{{ currency_symbols }}</strong>
                                            </span>
                                          </v-flex>
                                          <v-flex md1 sm1 xs3 pa-1 v-if="tax_item.percent == 0">
                                            <span>
                                              <strong>{{ currency_symbols }}</strong>
                                            </span>
                                          </v-flex>
                                          <v-flex md2 sm6 xs12 pa-1 v-if="tax_item.percent == 0">
                                            <v-text-field
                                              type="number"
                                              :label="currency_symbols"
                                              v-model="tax_item.value"
                                              :max="tax_item.max"
                                              :min="0"
                                              @change="tax_item.value = Math.max(Math.min(Math.trunc(tax_item.value), tax_item.max), 0)"
                                            />
                                          </v-flex>
                                        </v-layout>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-card-text>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-flex>
            </v-layout>

            <!-- <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-form ref="form" v-model="form_valid">
            <v-expansion-panel v-model="panel" expand>-->
            <!-- ข้อมูลพนักงาน -->
            <!-- <v-expansion-panel-content style="background-color:#B3E5FC" :key="0">
                      <div slot="header">
                        <h3>{{$t('EmployeeDetails')}}</h3>
            </div>-->
            <!-- <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex md12 sm12 xs12>
                              <v-layout row wrap>
                                <v-flex md6 sm6 xs12 text-xs-center hidden-sm-and-up>
                                  <v-layout row wrap>
                                    <v-flex xs12 style="margin-left:200px;margin-top:20px;">
                                      <v-icon @click="cancelimg()">far fa-times-circle</v-icon>
                                    </v-flex>
                                    <v-flex xs12>
                                      <v-avatar size="256" :tile="false" @click="uploadPic()">
                                        <v-icon
                                          size="256"
                                          color="black"
                                          style="cursor: pointer;"
                                          v-if="img == ''"
                                        >fa-image</v-icon>
                                        <img v-if="img != ''" :src="img" />
                                        <input
                                          type="file"
                                          id="file1"
                                          name="image"
                                          ref="file1"
                                          class="upload"
                                          @change="onChangePicture($event,1)"
                                          accept="image/*"
                                          capture
                                          style="display:none"
                                        />
                                      </v-avatar>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex md6 sm6 xs12 px-2>
                                  <v-layout row wrap>
                                    <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'create'">
                                      <v-text-field
                                        :label="$t('employee_code')"
                                        v-model="form_model.code"
                                        :rules="form_rules.code"
                                        @blur="getEmpDetail(form_model)"
                                        append-icon="fas fa-plus-circle"
                                        @click:append="doNewGuid"
                                      />
                                    </v-flex>

                                    <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type != 'create'">
                                      <v-text-field
                                        :label="$t('employee_code')"
                                        v-model="form_model.code"
                                        :rules="form_rules.code"
                                        readonly
                                      />
                                    </v-flex>
                                    
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('IDcard')"
                                        v-model="form_model.citizen_id"
                                        :rules="form_rules.citizen_id"
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('name')"
                                        v-model="form_model.first_name"
                                        :rules="form_rules.first_name"
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('lastname')"
                                        v-model="form_model.last_name"
                                        :rules="form_rules.last_name"
                                      
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('nickname')"
                                        v-model="form_model.nick_name"
                                        
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('birthday')"
                                        v-model="form_model.birth_date"
                                        type="date"
                                        
                                      />
                                    </v-flex>
                                    <v-flex md12 sm12 xs12 pa-1>
                                      <h3>{{$t('gender')}}</h3>
                                      <v-radio-group
                                        v-model="form_model.gender"
                                        :column="false"
                                        
                                      >
                                        <v-radio :label="$t('male')" value="male" />
                                        <v-radio :label="$t('female')" value="female" />
                                      </v-radio-group>
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('nationality')"
                                        v-model="form_model.nationality"
                                        
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1>
                                      <v-text-field
                                        :label="$t('race')"
                                        v-model="form_model.race"
                                        
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex md6 sm6 xs12 text-xs-center hidden-xs-only>
                                  <v-layout row wrap>
                                    <v-flex xs12 style="margin-left:200px;margin-top:20px;">
                                      <v-icon @click="cancelimg()">far fa-times-circle</v-icon>
                                    </v-flex>
                                    <v-flex xs12>
                                      <v-avatar size="256" :tile="false" @click="uploadPic()">
                                        <v-icon
                                          size="256"
                                          color="black"
                                          style="cursor: pointer;"
                                          v-if="img == ''"
                                        >fa-image</v-icon>
                                        <img v-if="img != ''" :src="img" />
                                        <input
                                          type="file"
                                          id="file1"
                                          name="image"
                                          ref="file1"
                                          class="upload"
                                          @change="onChangePicture($event,1)"
                                          accept="image/*"
                                          capture
                                          style="display:none"
                                        />
                                      </v-avatar>
                                    </v-flex>
            </v-layout>-->

            <!-- <v-avatar size="256" :tile="false" @click="uploadPic()">                                   
                                    <v-icon
                                      size="256"
                                      color="black"
                                      style="cursor: pointer;"
                                      v-if="img == ''"
                                    >fa-image</v-icon>
                                    <img v-if="img != ''" :src="img">
                                    <input
                                      type="file"
                                      id="file1"
                                      name="image"
                                      ref="file1"
                                      class="upload"
                                      @change="onChangePicture($event,1)"
                                      accept="image/*"
                                      capture
                                      style="display:none"
                                    >
            </v-avatar>-->
            <!-- </v-flex>

                                <v-flex xs12 px-2>
                                  <v-textarea
                                    :label="$t('Address')"
                                    v-model="form_model.address"
                                    
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap px-2>
                                <v-flex md4 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('TelephoneNumber')"
                                    v-model="form_model.phone_num"
                                    type="phone"
                                    
                                  />
                                </v-flex>
                                <v-flex md4 sm6 xs12 pa-1>
                                  <v-text-field
                                    label="LINE ID"
                                    v-model="form_model.line_id"
                                    
                                  />
                                </v-flex>
                                <v-flex md4 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('email')"
                                    v-model="form_model.email"
                                    
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
            </v-expansion-panel-content>-->
            <!-- ข้อมูลการทำงาน -->
            <!-- <v-expansion-panel-content style="background-color:#B3E5FC" :key="1">
                      <div slot="header">
                        <h3>{{$t('Workinformation')}}</h3>
                      </div>
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex md4 sm6 xs12 pa-1>
                              <h3>{{$t('status')}}</h3>
                              <v-layout row wrap>
                                <v-flex md12 sm12 xs12>
                                  <v-radio-group
                                    v-model="form_model.status"
                                    :column="false"
                                    
                                  >
                                    <v-radio :label="$t('apprentice')" value="0" />
                                    <v-radio :label="$t('placement')" value="1" />
                                    <v-radio :label="$t('suspended')" value="2" />
                                  </v-radio-group>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex md8 sm8 xs12>
                              <br />
                              <v-layout row wrap pa-1>
                                <v-flex md6 sm6 xs12>
                                  <v-checkbox
                                    :label="$t('NotusingTimeAttendancesystem')"
                                    value="1"
                                    v-model="form_model.not_cal_time"
                                    
                                  />
                                </v-flex>
                                <v-flex md6 sm6 xs12>
                                  <v-checkbox
                                    :label="$t('Donotcalculateworkdays')"
                                    value="1"
                                    v-model="form_model.is_special"
                                    
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex md4 sm4 xs12 pa-1>
                              <v-select
                                required
                                :items="branch_items"
                                :label="$t('branch')"
                                item-text="name"
                                item-value="code"
                                v-model="form_model.branch"
                                
                                @input="getProfileDepartmentList()"
                              />
                            </v-flex>
                            <v-flex md4 sm4 xs12 pa-1>
                              <v-select
                                required
                                :items="department_items"
                                :label="$t('Department')"
                                item-text="name"
                                item-value="code"
                                v-model="form_model.department"
                                
                              />
                            </v-flex>
                            <v-flex md4 sm4 xs12 pa-1>
                              <v-text-field
                                :label="$t('Position')"
                                v-model="form_model.position"
                                
                              />
                            </v-flex>
                            <v-flex md4 sm4 xs12 pa-1>
                              <v-text-field
                                :label="$t('startworkdate')"
                                v-model="form_model.start_work_date"
                                type="date"
                                @blur="formatdate(form_model.start_work_date)"
                                :rules="form_rules.start_work_date"
                                
                              />
                            </v-flex>
                            <v-flex md4 sm4 xs12 pa-1>
                              <v-text-field
                                :label="$t('Calculatehours')"
                                type="number"
                                v-model="form_model.calworkhour"
                                
                                required
                              />
                            </v-flex>
                          </v-layout>
            <br />-->
            <!-- ประเภทรายรับ -->
            <!-- <v-layout row wrap>
                            <v-flex md12 sm12 xs12 pa-1>
                              <h3>{{$t('IncomeType')}}</h3>
                              <v-layout row wrap>
                                <v-flex md4 sm4 xs12>
                                  <v-radio-group
                                    v-model="form_model.emp_type"
                                    :column="false"
                                    
                                  >
                                    <v-radio :label="$t('monthly')" value="0" />
                                    <v-radio :label="$t('Daily')" value="1" />
                                    <v-radio :label="$t('Hourly')" value="2" />
                                  </v-radio-group>
                                </v-flex>
                                <v-flex md8 sm8 xs12 pa-1>
                                  <v-layout row wrap v-show="form_model.emp_type == '0'">
                                    <v-flex
                                      md6
                                      sm6
                                      xs12
                                      pa-1
                                      v-if="json_data.save_type == 'create'"
                                    >
                                      <v-text-field
                                        :label="$t('Salary')"
                                        type="number"
                                        v-model="form_model.start_salary"
                                        
                                      />
                                    </v-flex>
                                    <v-flex
                                      md6
                                      sm6
                                      xs12
                                      pa-1
                                      v-if="json_data.save_type == 'update'"
                                    >
                                      <v-text-field
                                        :label="$t('Salary')"
                                        type="number"
                                        v-model="form_model.start_salary"
                                        
                                        readonly
                                        @click="Salarydialog = true"
                                      />
                                    </v-flex>
                                    <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'update'">
                                      <v-text-field
                                        :label="$t('CurrentSalary')"
                                        type="number"
                                        v-model="form_model.current_salary"
                                        
                                        readonly
                                      />
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap v-show="form_model.emp_type == '1'">
                                    <v-flex md12 sm12 xs12 mt-3>
                                      <v-layout row wrap>
                                        <v-flex md12 sm12 xs12>
                                          <v-radio-group
                                            v-model="form_model.earning_daytype"
                                            :column="false"
                                            
                                          >
                                            <v-radio :label="$t('standard')" value="0" />
                                            <v-radio :label="$t('Daily')" value="1" />
                                          </v-radio-group>
                                        </v-flex>
                                        <v-flex md12 sm12 xs12>
                                          <v-layout
                                            row
                                            wrap
                                            v-show="form_model.earning_daytype == '0'"
                                          >
                                            <v-flex xs12>
                                              <v-text-field
                                                :label="$t('dailyearnings')"
                                                v-model="form_model.daily_earnings"
                                                type="number"
                                                
                                              />
                                            </v-flex>
                                          </v-layout>
                                          <v-layout
                                            row
                                            wrap
                                            v-show="form_model.earning_daytype == '1'"
                                          >
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Monday')"
                                                type="number"
                                                v-model="form_model.daily_monday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Tuesday')"
                                                type="number"
                                                v-model="form_model.daily_tuesday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Wednesday')"
                                                type="number"
                                                v-model="form_model.daily_wednesday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Thursday')"
                                                type="number"
                                                v-model="form_model.daily_thursday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Friday')"
                                                type="number"
                                                v-model="form_model.daily_friday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Saturday')"
                                                type="number"
                                                v-model="form_model.daily_saturday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Sunday')"
                                                type="number"
                                                v-model="form_model.daily_sunday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Specialholiday')"
                                                type="number"
                                                v-model="form_model.daily_holiday"
                                                
                                              />
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row wrap v-show="form_model.emp_type == '2'">
                                    <v-flex md12 sm12 xs12 mt-3>
                                      <v-layout row wrap>
                                        <v-flex md12 sm12 xs12>
                                          <v-radio-group
                                            v-model="form_model.earning_hourtype"
                                            :column="false"
                                            
                                          >
                                            <v-radio :label="$t('standard')" value="0" />
                                            <v-radio :label="$t('Daily')" value="1" />
                                            <v-radio :label="$t('Packages')" value="2" />
                                          </v-radio-group>
                                        </v-flex>
                                        <v-flex md12 sm12 xs12>
                                          <v-layout
                                            row
                                            wrap
                                            v-show="form_model.earning_hourtype == '0'"
                                          >
                                            <v-flex md12 sm12 xs12>
                                              <v-text-field
                                                :label="$t('dailyearnings')"
                                                type="number"
                                                v-model="form_model.hourly_earnings"
                                                
                                              />
                                            </v-flex>
                                          </v-layout>
                                          <v-layout
                                            row
                                            wrap
                                            v-show="form_model.earning_hourtype == '1'"
                                          >
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Monday')"
                                                type="number"
                                                v-model="form_model.hour_monday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Tuesday')"
                                                type="number"
                                                v-model="form_model.hour_tuesday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Wednesday')"
                                                type="number"
                                                v-model="form_model.hour_wednesday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Thursday')"
                                                type="number"
                                                v-model="form_model.hour_thursday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Friday')"
                                                type="number"
                                                v-model="form_model.hour_friday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Saturday')"
                                                type="number"
                                                v-model="form_model.hour_saturday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Sunday')"
                                                type="number"
                                                v-model="form_model.hour_sunday"
                                                
                                              />
                                            </v-flex>
                                            <v-flex md2 sm2 xs3 pa-1>
                                              <v-text-field
                                                :label="$t('Specialholiday')"
                                                type="number"
                                                v-model="form_model.hour_holiday"
                                                
                                              />
                                            </v-flex>
                                          </v-layout>
                                          <v-layout
                                            row
                                            wrap
                                            v-show="form_model.earning_hourtype == '2'"
                                          >
                                            <v-flex md1 sm2 xs5>
                                              <v-text-field
                                                :label="$t('Fromtheamount')"
                                                v-model="form_model.form_hour_1"
                                                type="number"
                                                
                                              />
                                            </v-flex>
                                            <v-flex
                                              md1
                                              sm1
                                              xs2
                                              text-xs-center
                                              style="padding-top: 18px;"
                                            >
                                              <h3>-</h3>
                                            </v-flex>
                                            <v-flex md1 sm2 xs5>
                                              <v-text-field
                                                :label="$t('Toamount')"
                                                type="number"
                                                v-model="form_model.to_hour_1"
                                                
                                              />
                                            </v-flex>
                                            <v-flex
                                              md1
                                              sm1
                                              xs12
                                              text-xs-center
                                              style="padding-top: 18px;"
                                            >
                                              <h3>=</h3>
                                            </v-flex>
                                            <v-flex md1 sm2 xs12>
                                              <v-text-field
                                                :label="$t('menu.IncomeList')"
                                                type="number"
                                                v-model="form_model.hourearning_1"
                                                
                                              />
                                            </v-flex>
                                          </v-layout>
                                          <v-layout
                                            row
                                            wrap
                                            v-show="form_model.earning_hourtype == '2'"
                                          >
                                            <v-flex md1 sm2 xs5>
                                              <v-text-field
                                                :label="$t('Fromtheamount')"
                                                v-model="form_model.form_hour_2"
                                                type="number"
                                                
                                              />
                                            </v-flex>
                                            <v-flex
                                              md1
                                              sm1
                                              xs2
                                              text-xs-center
                                              style="padding-top: 18px;"
                                            >
                                              <h3>-</h3>
                                            </v-flex>
                                            <v-flex md1 sm2 xs5>
                                              <v-text-field
                                                :label="$t('Toamount')"
                                                type="number"
                                                v-model="form_model.to_hour_2"
                                                
                                              />
                                            </v-flex>
                                            <v-flex
                                              md1
                                              sm1
                                              xs12
                                              text-xs-center
                                              style="padding-top: 18px;"
                                            >
                                              <h3>=</h3>
                                            </v-flex>
                                            <v-flex md1 sm2 xs12>
                                              <v-text-field
                                                :label="$t('menu.IncomeList')"
                                                type="number"
                                                v-model="form_model.hourearning_2"  
                                              />
                                            </v-flex>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
            <br />-->
            <!-- อื่นๆ -->
            <!-- <v-layout row wrap pa-1>
                            <v-flex md4 sm4 xs12 px-2 pt-3>
                              <h3>{{$t('menu.HolidayList')}}</h3>
                              <v-select
                                required
                                :items="holidayProfile"
                                :label="$t('menu.HolidayList')"
                                v-model="form_model.holiday_profile"
                                item-text="name"
                                item-value="code"
                                
                              />
                            </v-flex>
                            <v-flex md8 sm8 xs12 mt-3>
                              <h3>{{$t('Weeklyholiday')}}</h3>
                              <v-layout row wrap px-2>
                                <v-flex md2 sm3 xs4 pa-1>
                                  <v-checkbox
                                    :label="$t('Monday')"
                                    v-model="weekend_mon"
                                    value="1"
                                    
                                  />
                                </v-flex>
                                <v-flex md2 sm3 xs4 pa-1>
                                  <v-checkbox
                                    :label="$t('Tuesday')"
                                    v-model="weekend_tue"
                                    value="1"
                                    
                                  />
                                </v-flex>
                                <v-flex md2 sm3 xs4 pa-1>
                                  <v-checkbox
                                    :label="$t('Wednesday')"
                                    v-model="weekend_wed"
                                    value="1"
                                    
                                  />
                                </v-flex>
                                <v-flex md2 sm3 xs4 pa-1>
                                  <v-checkbox
                                    :label="$t('Thursday')"
                                    v-model="weekend_thu"
                                    value="1"
                                    
                                  />
                                </v-flex>
                                <v-flex md2 sm3 xs4 pa-1>
                                  <v-checkbox
                                    :label="$t('Friday')"
                                    v-model="weekend_fri"
                                    value="1"
                                    
                                  />
                                </v-flex>
                                <v-flex md2 sm3 xs4 pa-1>
                                  <v-checkbox
                                    :label="$t('Saturday')"
                                    v-model="weekend_sat"
                                    value="1"
                                    
                                  />
                                </v-flex>
                                <v-flex md2 sm3 xs4 pa-1>
                                  <v-checkbox
                                    :label="$t('Sunday')"
                                    v-model="weekend_sun"
                                    value="1"
                                    
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex md4 sm4 xs12 px-2 >
                              <v-select
                                required
                                :items="profilePlan"
                                :label="$t('menu.WorkPlanList')"
                                v-model="form_model.shift_profile"
                                item-text="name"
                                item-value="code"
                                
                              />
                            </v-flex>
                            <v-flex md4 sm4 xs12 px-2 style="display:none;">
                              <v-select
                                required
                                :items="profileConditions"
                                :label="$t('menu.ConditionsList')"
                                v-model="form_model.conditions_profile"
                                item-text="name"
                                item-value="code"
                                
                              />
                            </v-flex>
                          </v-layout>
            <br />-->
            <!-- รายการหักเงิน -->
            <!-- <v-layout row wrap>
                            <v-flex md12 sm12 xs12 pa-1>
                              <h3>{{$t('listDeductions')}}</h3>
                              <v-layout row wrap>
                                <v-flex md4 sm4 xs12 pa-1>
                                  <v-checkbox
                                    :label="$t('Notusesocialsecuritypaymentsystem')"
                                    value="1"
                                    v-model="form_model.is_auto_ss"
                                    
                                  />
                                </v-flex>
                                <v-flex md8 sm8 xs12 pa-1>
                                  <v-checkbox
                                    :label="$t('Notusetaxcalculationsystem')"
                                    value="1"
                                    v-model="form_model.is_auto_tax"
                                    
                                  />
                                </v-flex>
                                <v-flex md4 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('SocialSecurity')"
                                    v-model="form_model.deduct_ss"
                                    type="number"
                                    
                                  />
                                </v-flex>
                                <v-flex md4 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('deducttax')"
                                    v-model="form_model.deduct_tax"
                                    type="number"
                                    
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
            <br />-->
            <!-- รายได้เสริม -->
            <!-- <v-layout row wrap>
                            <v-flex md12 sm12 xs12 pa-1>
                              <h3>{{$t('Otherextraincome')}}</h3>
                              <v-layout row wrap px-2>
                                <v-flex md4 sm4 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('craftAmount')"
                                    v-model="form_model.income_craft"
                                    
                                  />
                                </v-flex>
                                <v-flex md4 sm4 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('PositionAmount')"
                                    v-model="form_model.income_position"
                                    
                                  />
                                </v-flex>
                                <v-flex md4 sm4 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('extraAmount')"
                                    v-model="form_model.income_special"
                                    
                                  />
                                </v-flex>
            </v-layout>-->
            <!-- <v-layout row wrap>
                                <v-flex md4 sm4 xs12 pa-1 v-if="json_data.save_type == 'create'">
                                  <v-text-field
                                    :label="$t('craftAmount')"
                                    v-model="form_model.income_craft"
                                    
                                    type="number"
                                  />
                                </v-flex>
                                 <v-flex md4 sm4 xs12 pa-1  v-if="json_data.save_type == 'update'">
                                  <v-text-field
                                    :label="$t('craftAmount')"
                                    v-model="form_model.income_craft"
                                    
                                    type="number"
                                    readonly
                                  />
                                </v-flex>
                                <v-flex md4 sm4 xs12 pa-1 v-if="json_data.save_type == 'update'">
                                  <v-text-field
                                    :label="$t('current_craft')"
                                    v-model="form_model.current_craft"
                                    
                                    readonly
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex md4 sm4 xs12 pa-1 v-if="json_data.save_type == 'create'">
                                  <v-text-field
                                    :label="$t('PositionAmount')"
                                    v-model="form_model.income_position"
                                    
                                    type="number"
                                  />
                                </v-flex>
                                <v-flex md4 sm4 xs12 pa-1 v-if="json_data.save_type == 'update'">
                                  <v-text-field
                                    :label="$t('PositionAmount')"
                                    v-model="form_model.income_position"
                                    
                                    type="number"
                                    readonly
                                  />
                                </v-flex>
                                <v-flex md4 sm4 xs12 pa-1 v-if="json_data.save_type == 'update'">
                                  <v-text-field
                                    :label="$t('current_position')"
                                    v-model="form_model.current_position"
                                    
                                    readonly
                                  />
                                </v-flex>
                              </v-layout>
                               <v-layout row wrap>
                                <v-flex md4 sm4 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('extraAmount')"
                                    v-model="form_model.income_special"
                                    
                                    type="number"
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
            <br />-->
            <!-- ข้อมูลบัญชีรับเงินเดือน -->
            <!-- <v-layout row wrap>
                            <v-flex md12 sm12 xs12 pa-1>
                              <h3>{{$t('Bankaccountinformation')}}</h3>
                              <v-layout row wrap px-2>
                                <v-flex md6 sm6 xs12 pa-1>
                                  <v-select
                                    required
                                    :items="pay_items"
                                    :label="$t('PaymentType')"
                                    v-model="form_model.payment_type"
                                    item-text="name"
                                    item-value="code"
                                    
                                  />
            </v-flex>-->
            <!-- <v-flex md6 sm6 xs12 pa-1 hidden-xs-only /> -->
            <!-- <v-flex md6 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('Bank')"
                                    v-model="form_model.book_bank"
                                    
                                  />
                                </v-flex>
                                <v-flex md6 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('Bankaccount')"
                                    v-model="form_model.bank_code"
                                    
                                  />
                                </v-flex>
                                <v-flex md6 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('AccountName')"
                                    v-model="form_model.bank_name"
                                    
                                  />
                                </v-flex>
                                <v-flex md6 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('Prompay')"
                                    v-model="form_model.promptpay_number"
                                    
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
            </v-expansion-panel-content>-->
            <!-- ตั้งค่าเข้าสู่ระบบ -->
            <!-- <v-expansion-panel-content :key="2" style="background-color:#B3E5FC">
                      <div slot="header">
                        <h3>{{$t('loginpanel')}}</h3>
                      </div>
                      <v-card>
            <v-card-text>-->
            <!-- Username && Password -->
            <!-- <v-layout row wrap>
                            <v-flex md6 sm6 xs12 text-xs-center hidden-sm-and-up>
                              <v-avatar size="256" :tile="true" @click="''">
                                <v-icon size="256" color="black" style="cursor: pointer;">fa-image</v-icon>
                                <img src="''" alt="alt" style="display: none;" />
                              </v-avatar>
                            </v-flex>
                            <v-flex md6 sm6 xs12 px-2>
                              <v-layout row wrap>
                                <v-flex md6 sm6 xs12 pa-1>
                                  <v-text-field
                                    v-if="form_model.user_name == '' || form_model.user_name == 'null'"
                                    :label="$t('user_name')"
                                    v-model="user_name2"
                                    
                                  />
                                  <v-text-field
                                    v-else
                                    :label="$t('user_name')"
                                    v-model="form_model.user_name"
                                    readonly
                                    
                                  />
                                </v-flex>
                                <v-flex md6 sm6 xs12 pa-1>
                                  <v-text-field
                                    :label="$t('password')"
                                    v-model="form_model.user_password"
                                    
                                  />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
            </v-expansion-panel-content>-->
            <!-- ตั้งค่าภาษี -->
            <!-- <v-expansion-panel-content :key="3" style="background-color:#B3E5FC">
                      <div slot="header">
                        <h3>{{$t('menu.TaxSettingList')}}</h3>
            </div>-->
            <!-- <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex md4 sm4 xs12 pa-1>
                              <v-select
                                required
                                :items="years_items"
                                :label="$t('Year_tax')"
                                item-text="year_tax"
                                item-value="year_tax"
                                v-model="taxYear"
                                
                                @input="saveyear(taxYear)"
                              />
                            </v-flex>
                          </v-layout>
                        </v-card-text>
            </v-card>-->

            <!-- <v-card v-if="Taxshow">
                        <v-card-text>
                          <v-flex xs12 px-2 offset-md1>
                            <v-layout row wrap>
                              <v-flex lg1 md3 sm3 xs6 pa-2 offset-md1>
                                <h3>
                                  <strong>{{$t('Otherincome')}}</strong>
                                </h3>
            </v-flex>-->
            <!-- <v-flex lg2 md3 sm3 xs6 pa-2  >
                                <span>{{income_max}}</span>
            </v-flex>-->
            <!-- <v-flex md2 sm4 xs12 pa-2>
                                <v-text-field
                                  type="number"
                                  :label="$t('base')"
                                  v-model="income_value"
                                  :min="0"
                                />
                              </v-flex>
                            </v-layout>
                            <v-flex lg12 md12 sm12 xs12 pa-2 offset-md1>
                              <h3>
                                <strong>{{$t('Deductible')}}</strong>
                              </h3>
                            </v-flex>
                            <v-layout
                              row
                              wrap
                              v-for="(tax_item, index) in tax_details"
                              :key="index"
                              @click="''"
                            >
                              <v-layout row wrap v-if="tax_item.type==0">
                                <v-flex
                                  md1
                                  sm2
                                  xs6
                                  pa-2
                                  offset-md2
                                  offset-sm3
                                  v-if="tax_item.percent != 0"
                                  style="margin-bottom:30px;"
                                >
                                  <span>
                                    <strong>{{$t('Lessexpenses')}}{{$t('Rate')}}</strong>
                                  </span>
                                </v-flex>
                                <v-flex md1 sm2 xs6 pa-2 v-if="tax_item.percent != 0">
                                  <span>{{tax_item.percent}}</span>
                                </v-flex>
                                <v-flex
                                  md2
                                  sm4
                                  xs6
                                  pa-2
                                  offset-md2
                                  offset-sm3
                                  v-if="tax_item.percent == 0"
                                >
                                  <span v-if="tax_item.percent == 0">
                                    <strong>{{$t(tax_item.name)}}</strong>
                                  </span>
                                </v-flex>
                                <v-flex md1 sm2 xs6 pa-2 v-if="tax_item.percent != 0" style="margin-bottom:30px;">
                                  <span >
                                    <strong>{{$t('max_value')}}</strong>
                                  </span>
                                </v-flex>
                                <v-flex md1 sm2 xs6 pa-2 v-if="tax_item.percent == 0">
                                  <span >
                                    <strong>{{$t('max_value')}}</strong>
                                  </span>
                                </v-flex>
                                 <v-flex md1 sm2 xs3 pa-2 v-if="tax_item.percent != 0" style="margin-bottom:30px;">
                                  <span>{{tax_item.max}}</span>
                                </v-flex>
                                <v-flex md1 sm2 xs3 pa-2 v-if="tax_item.percent == 0">
                                  <span>{{tax_item.max}}</span>
                                </v-flex>
                                <v-flex md1 sm1 xs3 pa-2 v-if="tax_item.percent != 0"  style="margin-bottom:30px;">
                                  <span>
                                    <strong>{{currency_symbols}}</strong>
                                  </span>
                                </v-flex>
                                <v-flex md1 sm1 xs3 pa-2 v-if="tax_item.percent == 0">
                                  <span>
                                    <strong>{{currency_symbols}}</strong>
                                  </span>
                                  
                                </v-flex>
                                <v-flex md2 sm4 xs12 pa-1 v-if="tax_item.percent == 0">
                                  <v-text-field
                                    type="number"
                                    :label="currency_symbols"
                                    v-model="tax_item.value"
                                    :max="tax_item.max"
                                    :min="0"
                                    @change="tax_item.value =Math.max(Math.min(Math.round(tax_item.value),tax_item.max),0)"
                                    
                                  />
                                </v-flex>
                              </v-layout>
                            </v-layout>
                          </v-flex>
                        </v-card-text>
                      </v-card>
            </v-expansion-panel-content>-->
            <!-- </v-expansion-panel>
                </v-form>
              </v-flex>
            </v-layout>-->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right>
              <v-tooltip top>
                <v-btn slot="activator" dark fixed bottom right fab color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()" :disabled="button_none == 1">
                  <v-icon>save</v-icon>
                </v-btn>
                <span class="px-2">{{ json_data.save_type == "create" ? $t("create") : $t("save") }}</span>
              </v-tooltip>
            </v-flex>
            <!-- <v-flex xs12 text-xs-right v-if="json_data.save_type == 'update' ? button_none == 0: button_none == 1  ">
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
                disabled
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>-->
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Change Salary -->
    <v-layout row justify-center>
      <v-dialog v-model="Salarydialog" persistent max-width="350">
        <v-card>
          <v-card-title>
            <strong>
              <h3>
                <br />
                <v-icon>fa-info-circle</v-icon>
                &nbsp;{{ $t("Employee_dialog_changesalary") }}
              </h3>
            </strong>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <p text-md-center>
                  <br />
                  {{ $t("Employee_dialog_changesalaryat") }}
                </p>
                <strong>" {{ $t("Employee_dialog_AdjustmentMenu") }} "</strong>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="Salarydialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="type">
      {{ errmsg }}
      <v-btn dark flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <div class="text-xs-center">
      <v-dialog v-model="dialog_loading" persistent width="250">
        <v-card>
          <v-card-text align-center align-content-center justify-center>
            <h4>Processing.....</h4>
            <div class="lds-css ng-scope">
              <div style="width: 100%; height: 100%" class="lds-pacman">
                <div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import UserService from "@/services/UserService";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import MasterService from "@/services/MasterService";
import Utils from "@/utils/";
import numeral from "numeral";
import { async } from "q";

export default {
  props: {
    json_data: Object,
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        this.getEmpDetail(val.data);
      } else {
        console.log("ddsdassdqa");
        //this.$refs.form.reset();
        this.clearForm();
        this.taxYear = new Date().toISOString().substr(0, 4);
        //this.leaveYear = new Date().toISOString().substr(0, 4);
        this.saveyear(this.taxYear);
        // this.saveyearleave(leaveYear);
        this.doNewGuid();
      }
    },
    //  menu(val) {
    //   val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));

    // }
  },
  data: () => ({
    tabs: 0,
    currency_symbols: "",
    dialog_loading: false,
    user_name2: "",
    snackbar: false,
    income_max: 0,
    income_value: 0,
    tax_details: [],
    tax_master: [],
    tax_data: [],
    errmsg: "",
    type: "",
    Salarydialog: false,
    panel: [true, false, false, false],
    img: "",
    weekend_mon: "0",
    weekend_tue: "0",
    weekend_wed: "0",
    weekend_thu: "0",
    weekend_fri: "0",
    weekend_sat: "0",
    weekend_sun: "0",
    selectBranchName: "",
    selectDepName: "",
    form_model: {
      company_guid: "",
      user_name: "",
      user_password: "",
      code: "",
      name_title: "นาย",
      nick_name: "",
      is_auto_ss: "0",
      is_auto_tax: "0",
      is_training: "0",
      is_special: "1",
      plan_type: "0",
      first_name: "",
      weekends: "",
      holiday_profile: "",
      deduct_ss: 0,
      deduct_tax: 0,
      calworkhour: 8,
      income_craft: 0,
      current_craft: 0,
      income_position: 0,
      current_position: 0,
      income_special: 0,
      promptpay_number: "",
      not_cal_time: "0",
      payment_type: 0,
      last_name: "",
      nationality: "",
      emp_type: "0",
      earning_daytype: "0",
      daily_monday: 0,
      daily_tuesday: 0,
      daily_wednesday: 0,
      daily_thursday: 0,
      daily_friday: 0,
      daily_saturday: 0,
      daily_sunday: 0,
      daily_holiday: 0,
      earning_hourtype: "0",
      hour_monday: 0,
      hour_tuesday: 0,
      hour_wednesday: 0,
      hour_thursday: 0,
      hour_friday: 0,
      hour_saturday: 0,
      hour_sunday: 0,
      hour_holiday: 0,
      form_hour_1: 0,
      to_hour_1: 0,
      hourearning_1: 0,
      form_hour_2: 0,
      to_hour_2: 0,
      hourearning_2: 0,
      birth_date: "",
      address: "",
      gender: "male",
      phone_num: "",
      email: "",
      race: "",
      line_id: "",
      citizen_id: "",
      position: "",
      approver: localStorage._usercode,
      start_work_date: "",
      packing_date: "",
      status: "1",
      branch: "",
      faction: "",
      department: "",
      start_salary: 0,
      packing_salary: 0,
      daily_earnings: 0,
      hourly_earnings: 0,
      book_bank: "",
      bank_name: "",
      bank_code: "",
      shift_profile: "",
      conditions_profile: "",
      emp_images: [],
      tax_year: "",
      year_leave: "",
      taxsetting: {
        less_exp_rate: 50,
        less_exp_base: 100000,
        reduce_person: 60000,
        reduce_spouse: 0,
        reduce_child_rate: 0,
        reduce_child_base: 30000,
        reduce_parent_rate: 0,
        reduce_parent_base: 30000,
        reduce_handucap_rate: 0,
        reduce_handucap_base: 30000,
        reduce_insurance_base: 100000,
        reduce_insurance: 0,
        reduce_parent_insurance_base: 15000,
        reduce_parent_insurance: 0,
        reduce_inc_residence_base: 100000,
        reduce_inc_residence: 0,
        reduce_ltf: 0,
        reduce_long_insurance: 0,
        reduce_rmf: 0,
        reduct_name_1: "",
        reduct_name_2: "",
        reduct_name_3: "",
        reduct_name_4: "",
        reduct_name_5: "",
        reduct_name_6: "",
        reduct_name_7: "",
        reduct_name_8: "",
        reduct_name_9: "",
        reduct_name_10: "",
        reduct_value_1: 0,
        reduct_value_2: 0,
        reduct_value_3: 0,
        reduct_value_4: 0,
        reduct_value_5: 0,
        reduct_value_6: 0,
        reduct_value_7: 0,
        reduct_value_8: 0,
        reduct_value_9: 0,
        reduct_value_10: 0,
      },
      personal_leave_day: 0,
      personal_leave_hour: 0,
      sick_leave_day: 0,
      sick_leave_hour: 0,
      vacation_leave_day: 0,
      vacation_leave_hour: 0,
      ordination_leave_day: 0,
      ordination_leave_hour: 0,
      maternity_leave_day: 0,
      maternity_leave_hour: 0,
      military_service_leave_day: 0,
      military_service_leave_hour: 0,
      other_leave_day: 0,
      other_leave_hour: 0,
      creator_code: localStorage._usercode,
      tax_detail: [],
      other_income_detail: [],
    },
    leaveYear: "",
    profilePlan: [],
    profileConditions: [],
    Taxshow: false,
    table_data: [],
    form_rules: {
      code: [(v) => !!v || "กรุณากรอกข้อมูล."],
      first_name: [(v) => !!v || "กรุณากรอกข้อมูล."],
      last_name: [(v) => !!v || "กรุณากรอกข้อมูล."],
      branch: [(v) => !!v || "กรุณากรอกข้อมูล."],
      department: [(v) => !!v || "กรุณากรอกข้อมูล."],
      start_work_date: [(v) => !!v || "กรุณากรอกข้อมูล."],
      leave_id: [(v) => !!v || "กรุณากรอกข้อมูล."],
      username: [
        (v) => {
          const pat = /^(?=.*[a-z,A-Z])|(?=.*[0-9])(?=.{3,})/;
          return pat.test(v) || "กรอกเฉพาะตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น";
        },
      ],
      password: [
        (v) => {
          const pattern = /^(?=.*[0-9])(?=.{4,})/;
          return pattern.test(v) || "รหัสผ่านอย่างน้อย 4 ตัวเลข";
        },
      ],
    },
    timeattendance: 0,
    form_valid: false,
    branch_items: [],
    department_items: [],
    holidayProfile: [],
    pay_items: [
      {
        code: "0",
        name: "เงินโอน",
      },
      {
        code: "1",
        name: "พร้อมเพย์",
      },
      {
        code: "2",
        name: "เงินสด",
      },
      {
        code: "3",
        name: "อื่นๆ",
      },
    ],
    taxYear: "",
    years_items: [],
    items: [],
    menu: false,
    button_none: 0,
    leave_year: new Date().toISOString().substr(0, 4),
  }),
  created: async function() {
    //await this.clearForm();
    this.timeattendance = localStorage._is_timeattendance;
    await this.doNewGuid();
    await this.getProfileBranchList();
    // this.doNewGuid();
    await this.getTaxYearList();
    await this.getHolidayPlanList();
    await this.getProfilePlan();
    await this.getProfileConditions();
    await this.getEmployee();
    await this.createyear();

    this.Taxshow = false;
    this.taxYear = new Date().toISOString().substr(0, 4);
    //this.leaveYear = new Date().toISOString().substr(0, 4);
    //await this.saveyear(this.taxYear);
  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    closeDialog() {
      this.$emit("close-dialog");
      this.$refs.form.reset();
      //this.clearForm();
      this.tabs = 0;
    },
    // checkupdate(){
    //   console.log("แก้ไข");
    // },
    clearForm() {
      (this.user_name2 = ""), (this.img = "");
      this.panel = [true, false, false];
      this.weekend_mon = "0";
      this.weekend_tue = "0";
      this.weekend_wed = "0";
      this.weekend_thu = "0";
      this.weekend_fri = "0";
      this.weekend_sat = "0";
      this.weekend_sun = "0";
      // this.form_model.company_guid = "";
      // this.form_model.user_name = "";
      // this.form_model.user_password = "";
      // this.form_model.code = "";
      // this.form_model.name_title = "นาย";
      // this.form_model.nick_name = "";
      // this.form_model.is_auto_ss = "0";
      // this.form_model.is_auto_tax = "0";
      // this.form_model.is_training = "0";
      // this.form_model.is_special = "1";
      // this.form_model.plan_type = "0";
      // this.form_model.first_name = "";
      this.form_model = {
        company_id: localStorage._company_guid,
        company_guid: "",
        user_name: "",
        user_password: "",
        code: "",
        name_title: "นาย",
        nick_name: "",
        is_auto_ss: "0",
        is_auto_tax: "0",
        is_training: "0",
        is_special: "1",
        plan_type: "0",
        first_name: "",
        weekends: "",
        holiday_profile: "",
        deduct_ss: 0,
        deduct_tax: 0,
        calworkhour: 8,
        income_craft: 0,
        current_craft: 0,
        income_position: 0,
        current_position: 0,
        income_special: 0,
        promptpay_number: "",
        not_cal_time: "0",
        payment_type: 0,
        last_name: "",
        nationality: "",
        emp_type: "0",
        earning_daytype: "0",
        daily_monday: 0,
        daily_tuesday: 0,
        daily_wednesday: 0,
        daily_thursday: 0,
        daily_friday: 0,
        daily_saturday: 0,
        daily_sunday: 0,
        daily_holiday: 0,
        earning_hourtype: "0",
        hour_monday: 0,
        hour_tuesday: 0,
        hour_wednesday: 0,
        hour_thursday: 0,
        hour_friday: 0,
        hour_saturday: 0,
        hour_sunday: 0,
        hour_holiday: 0,
        form_hour_1: 0,
        to_hour_1: 0,
        hourearning_1: 0,
        form_hour_2: 0,
        to_hour_2: 0,
        hourearning_2: 0,
        birth_date: "",
        address: "",
        gender: "male",
        phone_num: "",
        email: "",
        race: "",
        line_id: "",
        citizen_id: "",
        position: "",
        approver: localStorage._usercode,
        start_work_date: "",
        packing_date: "",
        status: "1",
        branch: "",
        faction: "",
        department: "",
        start_salary: 0,
        packing_salary: 0,
        daily_earnings: 0,
        hourly_earnings: 0,
        book_bank: "",
        bank_name: "",
        bank_code: "",
        shift_profile: "",
        conditions_profile: "",
        emp_images: [],
        tax_year: "",
        year_leave: "",
        taxsetting: {
          less_exp_rate: 50,
          less_exp_base: 100000,
          reduce_person: 60000,
          reduce_spouse: 0,
          reduce_child_rate: 0,
          reduce_child_base: 30000,
          reduce_parent_rate: 0,
          reduce_parent_base: 30000,
          reduce_handucap_rate: 0,
          reduce_handucap_base: 30000,
          reduce_insurance_base: 100000,
          reduce_insurance: 0,
          reduce_parent_insurance_base: 15000,
          reduce_parent_insurance: 0,
          reduce_inc_residence_base: 100000,
          reduce_inc_residence: 0,
          reduce_ltf: 0,
          reduce_long_insurance: 0,
          reduce_rmf: 0,
          reduct_name_1: "",
          reduct_name_2: "",
          reduct_name_3: "",
          reduct_name_4: "",
          reduct_name_5: "",
          reduct_name_6: "",
          reduct_name_7: "",
          reduct_name_8: "",
          reduct_name_9: "",
          reduct_name_10: "",
          reduct_value_1: 0,
          reduct_value_2: 0,
          reduct_value_3: 0,
          reduct_value_4: 0,
          reduct_value_5: 0,
          reduct_value_6: 0,
          reduct_value_7: 0,
          reduct_value_8: 0,
          reduct_value_9: 0,
          reduct_value_10: 0,
          company_id: localStorage._company_guid,
        },

        personal_leave_day: 0,
        personal_leave_hour: 0,
        sick_leave_day: 0,
        sick_leave_hour: 0,
        vacation_leave_day: 0,
        vacation_leave_hour: 0,
        ordination_leave_day: 0,
        ordination_leave_hour: 0,
        maternity_leave_day: 0,
        maternity_leave_hour: 0,
        military_service_leave_day: 0,
        military_service_leave_hour: 0,
        other_leave_day: 0,
        other_leave_hour: 0,
        creator_code: localStorage._usercode,
        tax_detail: [],
        other_income_detail: [],
      };

      if (this.branch_items.length > 0) {
        console.log("branch list", this.branch_items[0].code);

        this.form_model.branch = this.branch_items[0].code;
        this.selectBranchName = this.branch_items[0].name;
      }
    },
    doNewGuid() {
      this.form_model.code = Utils.newGuid("EMP");
    },
    getProfilePlan() {
      this.profilePlan = [];
      this.profilePlan.push({
        code: "",
        name: "ไม่ใช้แผนการทำงาน",
      });
      SettingService.getProfileAllPlan()
        .then((res) => {
          res.data.content.forEach((element) => {
            this.profilePlan.push({
              code: element.code,
              name: element.name,
            });
          });
          //this.profilePlan = res.data.content;
          console.log(this.profilePlan);
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    getProfileConditions() {
      this.profileConditions = [];
      this.profileConditions.push({
        code: "",
        name: "ไม่ใช้เงื่อนไขการหักและรับเงิน",
      });
      SettingService.getProfileConditions()
        .then((res) => {
          res.data.content.forEach((element) => {
            this.profileConditions.push({
              code: element.code,
              name: element.name,
            });
          });
          // this.profileConditions = res.data.content;
          console.log(this.profileConditions);
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_items = res.data.content;
          this.form_model.branch = this.branch_items[0].code;
          this.selectBranchName = this.branch_items[0].name;
          this.getProfileDepartmentList();

          //console.log(this.branch_items);
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    formatdate(date) {
      var year = null;
      year = new Date(date).toISOString().substr(0, 4);
      // console.log("date",year)
      if (year > "2200") {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกรูปแบบวันเริ่มทำงานเป็นปี ค.ศ.";
        this.type = "error";
        this.button_none = 1;
      } else {
        this.button_none = 0;
      }
    },
    addOtherIncome() {
      this.form_model.other_income_detail.push({
        cal_ss: 0,
        name: "",
        value: 0,
        company_id : localStorage._company_guid
      });
    },
    removeOtherIncome(index) {
      this.form_model.other_income_detail.splice(index, 1);
    },
    getEmpDetail(data) {
      //console.log(data);

      var code = this.form_model.code;

      EmployeeService.getEmployeeDetail(data.code)
        .then((res) => {
          console.log("ee", res.data);
          //console.log("birth:",res.data.birth_date);
          if (res.data != "") {
            this.form_model = res.data;
            this.form_model.user_name = res.data.user_name + "";
            this.form_model.user_password = res.data.user_password + "";
            this.form_model.earning_daytype = res.data.earning_daytype + "";
            this.form_model.earning_hourtype = res.data.earning_hourtype + "";
            this.form_model.is_auto_ss = res.data.is_auto_ss + "";
            this.form_model.is_auto_tax = res.data.is_auto_tax + "";
            this.form_model.is_special = res.data.is_special + "";
            this.form_model.is_training = res.data.is_training + "";
            this.form_model.emp_type = res.data.emp_type + "";
            this.form_model.status = res.data.status + "";
            this.form_model.payment_type = res.data.payment_type + "";
            this.img = res.data.emp_images;
            this.form_model.tax_year = res.data.tax_year;
            this.form_model.year_leave = res.data.year_leave;
            this.leave_year = res.data.year_leave;
            this.getProfileDepartmentListEdit(res.data.department);
            console.log("eee", this.leave_year);
            this.createyear();
            if (this.form_model.personal_leave_day == undefined) {
              this.form_model.personal_leave_day = 0;
            } else {
              this.form_model.personal_leave_day = res.data.personal_leave_day;
            }
            if (this.form_model.personal_leave_hour == undefined) {
              this.form_model.personal_leave_hour = 0;
            } else {
              this.form_model.personal_leave_hour = res.data.personal_leave_hour;
            }
            if (this.form_model.sick_leave_day == undefined) {
              this.form_model.sick_leave_day = 0;
            } else {
              this.form_model.sick_leave_day = res.data.sick_leave_day;
            }
            if (this.form_model.sick_leave_hour == undefined) {
              this.form_model.sick_leave_hour = 0;
            } else {
              this.form_model.sick_leave_hour = res.data.sick_leave_hour;
            }
            if (this.form_model.vacation_leave_day == undefined) {
              this.form_model.vacation_leave_day = 0;
            } else {
              this.form_model.vacation_leave_day = res.data.vacation_leave_day;
            }
            if (this.form_model.vacation_leave_hour == undefined) {
              this.form_model.vacation_leave_hour = 0;
            } else {
              this.form_model.vacation_leave_hour = res.data.vacation_leave_hour;
            }
            if (this.form_model.ordination_leave_day == undefined) {
              this.form_model.ordination_leave_day = 0;
            } else {
              this.form_model.ordination_leave_day = res.data.ordination_leave_day;
            }
            if (this.form_model.ordination_leave_hour == undefined) {
              this.form_model.ordination_leave_hour = 0;
            } else {
              this.form_model.ordination_leave_hour = res.data.ordination_leave_hour;
            }
            if (this.form_model.maternity_leave_day == undefined) {
              this.form_model.maternity_leave_day = 0;
            } else {
              this.form_model.maternity_leave_day = res.data.maternity_leave_day;
            }
            if (this.form_model.maternity_leave_hour == undefined) {
              this.form_model.maternity_leave_hour = 0;
            } else {
              this.form_model.maternity_leave_hour = res.data.maternity_leave_hour;
            }
            if (this.form_model.military_service_leave_day == undefined) {
              this.form_model.military_service_leave_day = 0;
            } else {
              this.form_model.military_service_leave_day = res.data.military_service_leave_day;
            }
            if (this.form_model.military_service_leave_hour == undefined) {
              this.form_model.military_service_leave_hour = 0;
            } else {
              this.form_model.military_service_leave_hour = res.data.military_service_leave_hour;
            }
            if (this.form_model.other_leave_day == undefined) {
              this.form_model.other_leave_day = 0;
            } else {
              this.form_model.other_leave_day = res.data.other_leave_day;
            }
            if (this.form_model.other_leave_hour == undefined) {
              this.form_model.other_leave_hour = 0;
            } else {
              this.form_model.other_leave_hour = res.data.other_leave_hour;
            }

            // if(this.form_model.year_leave == null ||(this.form_model.year_leave == "" && this.form_model.leave_detail.length != 0)){
            //     this.form_model.year_leave = this.leaveYear;
            //     this.saveyearleave(this.leaveYear);
            // }
            // if(this.form_model.year_leave != null && this.form_model.leave_detail.length == 0){
            //     this.leaveYear = this.form_model.year_leave;
            //     this.saveyearleave(this.leaveYear);
            // }
            // if (
            //   this.form_model.year_leave != null &&
            //   this.form_model.year_leave != "" &&
            //   this.form_model.leave_detail.length != 0
            // ) {
            //   this.leaveYear = this.form_model.year_leave;
            //   this.saveyearleave(this.leaveYear);

            // }
            this.taxYear = new Date().toISOString().substr(0, 4);
            this.form_model.tax_year = this.taxYear;
            console.log("yyyy", this.form_model.tax_year);

            this.saveyear(this.taxYear);

            if (this.form_model.taxsetting == null) {
              this.form_model.taxsetting = {
                less_exp_rate: 50,
                less_exp_base: 100000,
                reduce_person: 60000,
                reduce_spouse: 0,
                reduce_child_rate: 0,
                reduce_child_base: 30000,
                reduce_parent_rate: 0,
                reduce_parent_base: 30000,
                reduce_handucap_rate: 0,
                reduce_handucap_base: 30000,
                reduce_insurance_base: 100000,
                reduce_insurance: 0,
                reduce_parent_insurance_base: 15000,
                reduce_parent_insurance: 0,
                reduce_inc_residence_base: 100000,
                reduce_inc_residence: 0,
                reduce_ltf: 0,
                reduce_long_insurance: 0,
                reduce_rmf: 0,
                reduct_name_1: "",
                reduct_name_2: "",
                reduct_name_3: "",
                reduct_name_4: "",
                reduct_name_5: "",
                reduct_name_6: "",
                reduct_name_7: "",
                reduct_name_8: "",
                reduct_name_9: "",
                reduct_name_10: "",
                reduct_value_1: 0,
                reduct_value_2: 0,
                reduct_value_3: 0,
                reduct_value_4: 0,
                reduct_value_5: 0,
                reduct_value_6: 0,
                reduct_value_7: 0,
                reduct_value_8: 0,
                reduct_value_9: 0,
                reduct_value_10: 0,
              };
            }

            if (this.form_model.weekends != "" && this.form_model.weekends != null) {
              let split = this.form_model.weekends.split(",");
              split.forEach((ele) => {
                if (ele == "Sun") {
                  this.weekend_sun = "1";
                } else if (ele == "Mon") {
                  this.weekend_mon = "1";
                } else if (ele == "Tue") {
                  this.weekend_tue = "1";
                } else if (ele == "Wed") {
                  this.weekend_wed = "1";
                } else if (ele == "Thu") {
                  this.weekend_thu = "1";
                } else if (ele == "Fri") {
                  this.weekend_fri = "1";
                } else if (ele == "Sat") {
                  this.weekend_sat = "1";
                }
              });
            } else {
              this.weekend_sun = "0";
              this.weekend_mon = "0";
              this.weekend_tue = "0";
              this.weekend_wed = "0";
              this.weekend_thu = "0";
              this.weekend_fri = "0";
              this.weekend_sat = "0";
            }
          } else {
            this.form_model.code = code;
          }
          this.getProfileDepartmentList();
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    getHolidayPlanList() {
      console.log(this.holidayProfile);
      SettingService.getHolidayPlanList()
        .then((res) => {
          this.holidayProfile = res.data;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
          //console.log(this.department_items);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getBranchName() {
      if (this.branch_items.length > 0) {
        var found = this.branch_items.filter((d) => d.code == this.form_model.branch);
        if (found.length > 0) {
          return found[0].name;
        } else {
          return this.selectBranchName;
        }
      } else {
        return this.selectBranchName;
      }
    },
    getProfileDepartmentList() {
      this.form_model.department = "";
      SettingService.getDepartmentByBranch(this.form_model.branch)
        .then((res) => {
          this.department_items = res.data;
          //console.log(this.department_items);
        })
        .catch((err) => {
          //console.log(err);
        });
    },

    getProfileDepartmentListEdit(data) {
      SettingService.getDepartmentByBranch(this.form_model.branch)
        .then((res) => {
          this.department_items = res.data;
          this.form_model.department = data;
          this.selectDepName = res.data.filter((d) => d.code == data)[0].name;
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    uploadPic($event) {
      const elem = this.$refs.file1;
      elem.click();
    },
    readThisdata(inputValue, index) {
      const file = inputValue.files[0];
      const myReader = new FileReader();
      myReader.onloadend = (e) => {
        this.img = myReader.result;
      };
      myReader.readAsDataURL(file);
    },
    onChangePicture($event, index) {
      this.readThisdata($event.target, index);
    },
    getWeekendsAndImg() {
      this.form_model.weekends = "";
      let checkbox_week = [];

      if (this.weekend_sun == "1") {
        checkbox_week.push("Sun");
      }
      if (this.weekend_mon == "1") {
        checkbox_week.push("Mon");
      }
      if (this.weekend_tue == "1") {
        checkbox_week.push("Tue");
      }
      if (this.weekend_wed == "1") {
        checkbox_week.push("Wed");
      }
      if (this.weekend_thu == "1") {
        checkbox_week.push("Thu");
      }
      if (this.weekend_fri == "1") {
        checkbox_week.push("Fri");
      }
      if (this.weekend_sat == "1") {
        checkbox_week.push("Sat");
      }

      for (var i = 0; i < checkbox_week.length; i++) {
        if (i == 0) {
          this.form_model.weekends = checkbox_week[i];
        } else {
          this.form_model.weekends += "," + checkbox_week[i];
        }
      }

      this.form_model.emp_images = [];
      if (this.img != "") {
        var rep_img1 = this.img.replace("data:image/png;base64,", "");
        var rep_img2 = rep_img1.replace("data:image/gif;base64,", "");
        var rep_img3 = rep_img2.replace("data:image/jpg;base64,", "");
        var rep_img4 = rep_img3.replace("data:image/bmp;base64,", "");
        var rep_img5 = rep_img4.replace("data:image/jpeg;base64,", "");

        this.form_model.emp_images.push({
          image_file: rep_img5,
        });
      }
    },
    onSave() {
      var leave_year;

      if (this.leave_year != null) {
        leave_year = this.leave_year;
      } else {
        leave_year = this.leave_year;
      }
      this.form_model.year_leave = leave_year;

      if (this.income_value >= 0 && this.tax_details != "") {
        this.tax_details[0].value = this.income_value;
        //console.log("5555", this.tax_details[0].values);
        this.form_model.tax_detail = this.tax_details;
      }

      if (this.form_model.taxsetting.reduce_child_rate > 3) {
        this.form_model.taxsetting.reduce_child_rate = 3;
      }

      if (this.form_model.taxsetting.reduce_insurance > this.form_model.taxsetting.reduce_insurance_base) {
        this.form_model.taxsetting.reduce_insurance = this.form_model.taxsetting.reduce_insurance_base;
      }

      if (this.form_model.taxsetting.reduce_parent_insurance > this.form_model.taxsetting.reduce_parent_insurance_base) {
        this.form_model.taxsetting.reduce_parent_insurance = this.form_model.taxsetting.reduce_parent_insurance_base;
      }

      if (this.form_model.taxsetting.reduce_inc_residence > this.form_model.taxsetting.reduce_inc_residence_base) {
        this.form_model.taxsetting.reduce_inc_residence = this.form_model.taxsetting.reduce_inc_residence_base;
      }

      this.form_model.company_guid = localStorage._company_guid;

      if (this.user_name2 != "") {
        this.form_model.user_name = this.user_name2;
      } else if (this.user_name2 == "" || this.user_name2 == undefined) {
        this.form_model.user_name = "";
      }
      if (this.form_model.user_password == undefined || this.form_model.user_password == "") {
        this.form_model.user_password = "";
      } else {
        this.form_model.user_password = this.form_model.user_password;
      }

      if (this.form_model.shift_profile == "" && this.form_model.is_special == "0") {
        this.form_model.is_special = "1";
      }

      if (this.form_model.code == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มรหัสพนักงาน";
        this.type = "error";
        this.form_model.code = null;
        this.tabs = 0;
      } else if (this.form_model.first_name == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มชื่อพนักงาน";
        this.type = "error";
        this.form_model.first_name = null;
        this.tabs = 0;
      } else if (this.form_model.last_name == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มนามสกุลพนักงาน";
        this.type = "error";
        this.form_model.last_name = null;
        this.tabs = 0;
      } else if (this.form_model.start_work_date == "") {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกวันที่เริ่มงาน";
        this.type = "error";
        this.form_model.start_work_date = null;
        this.tabs = 1;
      } else if (this.form_model.year_leave == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเลือกปีการลา";
        this.type = "error";
        this.form_model.year_leave = null;
        this.tabs = 1;
      } else if (this.form_model.start_salary < 0) {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกเงินเดือนเริ่มต้น";
        this.type = "error";
        this.tabs = 1;
        this.form_model.start_salary = 0;
      } else if (this.form_model.user_name == "" && this.form_model.user_password != "") {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกชื่อผู้ใช้ระบบ";
        console.log("กรุณากรอกชื่อผู้ใช้ระบบ: ");
        this.type = "error";
        this.tabs = 0;
      }

      // else if ( this.form_model.user_name != ""&&this.form_model.user_name != undefined && this.form_model.user_password == ""
      // ) {
      //      console.log(this.form_model.user_name);
      //      console.log("กรุณากรอกรหัสผ่าน: ");
      //   this.snackbar = true;
      //   this.errmsg = "กรุณากรอกรหัสผ่าน";
      //   this.type = "error"
      //   this.tabs = 0;
      // }
      else {

        this.form_model.other_income_detail = this.form_model.other_income_detail.filter(item => item.name !== null && item.name !== "");

        this.dialog_loading = true;

        this.getWeekendsAndImg();

        this.form_model.company_id = localStorage._company_guid;
        console.log("onsave: ", this.form_model);

        EmployeeService.createEmployee(this.form_model)
          .then((res) => {
            this.dialog_loading = false;
            this.Taxshow = false;
            this.tabs = 0;
            this.closeDialog();
          })
          .catch((err) => {
            this.dialog_loading = false;
            this.snackbar = true;
            this.errmsg = "Resources exist";
          });
      }
    },
    selectedformatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    checkUser(username) {
      console.log("ddddd", username);
      if (username == "" || username == null) {
      } else {
        UserService.getCheckUser(username)
          .then((res) => {
            this.snackbar = true;
            this.errmsg = "ชื่อนี้ใช้ได้";
            this.type = "success";
            console.log(res);
          })
          .catch((err) => {
            this.snackbar = true;
            this.errmsg = "มีชื่อผู้ใช้นี้ในระบบแล้ว";
            this.type = "error";
            console.log(err);
          });
      }
    },
    onUpdate() {
      var leave_year;

      if (this.leave_year != null) {
        leave_year = this.leave_year;
      } else {
        leave_year = this.leave_year;
      }
      this.form_model.year_leave = leave_year;
      if (this.income_value >= 0 && this.tax_details != "") {
        this.tax_details[0].value = this.income_value;
        this.form_model.tax_detail = this.tax_details;
      }
      if (this.form_model.taxsetting.reduce_child_rate > 3) {
        this.form_model.taxsetting.reduce_child_rate = 3;
      }

      if (this.form_model.taxsetting.reduce_insurance > this.form_model.taxsetting.reduce_insurance_base) {
        this.form_model.taxsetting.reduce_insurance = this.form_model.taxsetting.reduce_insurance_base;
      }

      if (this.form_model.taxsetting.reduce_parent_insurance > this.form_model.taxsetting.reduce_parent_insurance_base) {
        this.form_model.taxsetting.reduce_parent_insurance = this.form_model.taxsetting.reduce_parent_insurance_base;
      }

      if (this.form_model.taxsetting.reduce_inc_residence > this.form_model.taxsetting.reduce_inc_residence_base) {
        this.form_model.taxsetting.reduce_inc_residence = this.form_model.taxsetting.reduce_inc_residence_base;
      }

      this.form_model.company_guid = localStorage._company_guid;

      if (this.user_name2 != "" && this.user_name2 != undefined) {
        this.form_model.user_name = this.user_name2;
      } else if (this.user_name2 == "" || this.user_name2 == undefined) {
        this.form_model.user_name = this.form_model.user_name;
        this.form_model.user_password = this.form_model.user_password;
      }
      if (this.form_model.user_password == undefined || this.form_model.user_password == "") {
        this.form_model.user_password = "";
      } else {
        this.form_model.user_password = this.form_model.user_password;
      }

      if (this.form_model.code == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มรหัสพนักงาน";
        this.type = "error";
        this.tabs = 0;
        this.form_model.code == null;
      } else if (this.form_model.first_name == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มชื่อพนักงาน";
        this.type = "error";
        this.tabs = 0;
        this.form_model.first_name == null;
      } else if (this.form_model.last_name == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเพิ่มนามสกุลพนักงาน";
        this.type = "error";
        this.tabs = 0;
        this.form_model.last_name == null;
      } else if (this.form_model.year_leave == "") {
        this.snackbar = true;
        this.errmsg = "กรุณาเลือกปีการลา";
        this.type = "error";
        this.form_model.year_leave = null;
        this.tabs = 1;
      } else if (this.form_model.start_work_date == "") {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกวันที่เริ่มงาน";
        this.type = "error";
        this.tabs = 1;
        this.form_model.start_work_date == null;
      } else if (this.form_model.user_name == "" && this.form_model.user_password != "") {
        this.snackbar = true;
        this.errmsg = "กรุณากรอกชื่อผู้ใช้ระบบ";
        this.type = "error";
        this.tabs = 0;
        this.form_model.user_name = null;
      }
      // else if (
      //   this.form_model.user_name != "" &&
      //   this.form_model.user_password == ""
      // ) {
      //   this.snackbar = true;
      //   this.errmsg = "กรุณากรอกรห้สผ่าน ";
      //   this.type = "error"
      //   this.tabs = 0;
      //    this.form_model.user_password = null;
      // }
      else {
        this.dialog_loading = true;

        this.getWeekendsAndImg();
        // if (this.form_model.user_password == undefined) {
        //   this.form_model.user_password == "";
        // }
        //console.log("dddd", this.form_model.not_cal_time);
        this.form_model.company_id = localStorage._company_guid;
        console.log("dd", this.form_model);

        EmployeeService.updateEmployee(this.form_model)
          .then((res) => {
            this.dialog_loading = false;
            //this.$refs.form.reset()
            this.Taxshow = false;
            this.tabs = 0;

            this.closeDialog();
          })
          .catch((err) => {
            this.dialog_loading = false;
            //console.log(err);
          });
      }
    },
    cancelimg() {
      this.img = "";
    },
    getTaxYearList() {
      SettingService.gettaxList()
        .then((res) => {
          console.log("year", res);
          this.years_items = res.data;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    async saveyear(date) {
      this.tax_details = [];
      this.form_model.tax_year = date;
      await SettingService.getGeneralSetting().then((res) => {
        this.currency_symbols = res.data.content[0].currency_symbols;
        this.Taxshow = true;
        // console.log(this.currency_symbols);
      });
      if (date == "" || date == undefined) {
        this.Taxshow = false;
      } else if ((date != this.form_model.tax_year || date == this.form_model.tax_year) && this.form_model.tax_detail.length == 0) {
        await SettingService.getTaxdetail(date).then((res) => {
          //console.log("tax detail");
          console.log(res.data);
          this.Taxshow = true;
          if (res.data != "") {
            this.form_model.tax_year = date;
            res.data.tax_detail.forEach((element) => {
              if (element.name == "personal") {
                this.tax_details.push({
                  year_tax: date,
                  name: element.name,
                  type: element.type,
                  percent: element.percent,
                  max: element.max,
                  value: element.max,
                  company_id: localStorage._company_guid,
                });
              } else {
                this.tax_details.push({
                  year_tax: date,
                  name: element.name,
                  type: element.type,
                  percent: element.percent,
                  max: element.max,
                  value: 0,
                  company_id: localStorage._company_guid,
                });
              }
            });
          }
          this.tax_details.forEach((check) => {
            if (check.type == 1) {
              this.income_max = check.max;
              this.income_value = check.value;
              //console.log(this.income_value);
            }
          });
        });
      } else if (date == this.form_model.tax_year && this.form_model.tax_detail.length > 0) {
        this.tax_master = [];
        await SettingService.getTaxdetail(date).then((res) => {
          //console.log(res.data);
          if (res.data != "") {
            this.form_model.tax_year = date;

            res.data.tax_detail.forEach((element) => {
              if (element.name == "personal") {
                this.tax_master.push({
                  year_tax: date,
                  name: element.name,
                  type: element.type,
                  percent: element.percent,
                  max: element.max,
                  value: element.max,
                  company_id: localStorage._company_guid,
                });
              } else {
                this.tax_master.push({
                  year_tax: date,
                  name: element.name,
                  type: element.type,
                  percent: element.percent,
                  max: element.max,
                  value: 0,
                  company_id: localStorage._company_guid,
                });
              }
            });
            console.log("sssss", this.tax_master);
          }
        });
        this.tax_data = this.form_model.tax_detail;
        //console.log(this.tax_data)
        await this.tax_master.forEach(async (master) => {
          let value = 0;
          await this.tax_data.forEach((data) => {
            if (master.name == data.name) {
              value = data.value;
              // console.log(value);
            }
          });
          await this.tax_details.push({
            year_tax: date,
            name: master.name,
            type: master.type,
            percent: master.percent,
            max: master.max,
            value: value,
            company_id: localStorage._company_guid,
          });
        });

        await this.tax_details.forEach((check) => {
          if (check.type == 1) {
            this.income_max = check.max;
            this.income_value = check.value;
            //console.log(this.income_value);
          }
        });
        this.Taxshow = true;
      }
    },
    createyear() {
      var curryears = new Date().toISOString().substr(0, 4);
      var startyear = parseInt(curryears) - 5;
      var endyear = parseInt(curryears) + 5;
      console.log("curryears", curryears);
      console.log("startyear", startyear);
      console.log("endyear", endyear);
      for (var d = startyear; d <= endyear; d++) {
        this.items.push(d + "");
      }
      console.log(this.items);
    },
    // async saveyearleave(date) {
    //   this.leave_details = [];
    //   this.form_model.year_leave = date;
    //   if (date != this.form_model.year_leave || date == this.form_model.year_leave) {
    //     await MasterService.getDetailsLeaveByCode(date).then((res) => {
    //       console.log(res.data);
    //       if (res.data != "") {
    //         this.form_model.year_leave = date;
    //         this.form_model.personal_leave_day = res.data.leave_detail.personal_leave_day,
    //         this.form_model.personal_leave_hour = res.data.leave_detail.personal_leave_hour,
    //         this.form_model.sick_leave_day = res.data.leave_detail.sick_leave_day,
    //         this.form_model.sick_leave_hour = res.data.leave_detail.sick_leave_hour,
    //         this.form_model.vacation_leave_day = res.data.leave_detail.vacation_leave_day,
    //         this.form_model.vacation_leave_hour = res.data.leave_detail.vacation_leave_hour,
    //         this.form_model.ordination_leave_day = res.data.leave_detail.ordination_leave_day,
    //         this.form_model.ordination_leave_hour = res.data.leave_detail.ordination_leave_hour,
    //         this.form_model.maternity_leave_day = res.data.leave_detail.maternity_leave_day,
    //         this.form_model.maternity_leave_hour = res.data.leave_detail.maternity_leave_hour,
    //         this.form_model.military_service_leave_day = res.data.leave_detail.military_service_leave_day,
    //         this.form_model.military_service_leave_hour = res.data.leave_detail.military_service_leave_hour,
    //         this.form_model.this.form_model.other_leave_day = res.data.leave_detail.other_leave_day,
    //         this.form_model.other_leave_hour = res.data.leave_detail.other_leave_hour
    //       }
    //     });
    //   }
    // },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
h1,
label,
span,
h3,
strong,
p {
  font-family: "Prompt", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}

.v-card__text {
  padding: 0px !important;
}
.v-toolbar__title {
  font-family: "Prompt", sans-serif;
}
.text-topic {
  background-color: #b1afaf;
  color: #fff;
  padding: 15px;
}
.background {
  background: url("../../assets/banner1.png") no-repeat fixed top;
  z-index: 202;
}
</style>
<style type="text/css">
@keyframes lds-pacman-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@-webkit-keyframes lds-pacman-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@keyframes lds-pacman-2 {
  0% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@-webkit-keyframes lds-pacman-2 {
  0% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@keyframes lds-pacman-3 {
  0% {
    -webkit-transform: translate(190px, 0);
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(70px, 0);
    transform: translate(70px, 0);
    opacity: 1;
  }
}
@-webkit-keyframes lds-pacman-3 {
  0% {
    -webkit-transform: translate(190px, 0);
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(70px, 0);
    transform: translate(70px, 0);
    opacity: 1;
  }
}
.lds-pacman {
  position: relative;
}
.lds-pacman > div:nth-child(2) div {
  position: absolute;
  top: 40px;
  left: 40px;
  width: 120px;
  height: 60px;
  border-radius: 120px 120px 0 0;
  background: #3be8ce;
  -webkit-animation: lds-pacman-1 0.9s linear infinite;
  animation: lds-pacman-1 0.9s linear infinite;
  -webkit-transform-origin: 60px 60px;
  transform-origin: 60px 60px;
}
.lds-pacman > div:nth-child(2) div:nth-child(2) {
  -webkit-animation: lds-pacman-2 0.9s linear infinite;
  animation: lds-pacman-2 0.9s linear infinite;
}
.lds-pacman > div:nth-child(1) div {
  position: absolute;
  top: 92px;
  left: -8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1ec7ed;
  -webkit-animation: lds-pacman-3 0.9s linear infinite;
  animation: lds-pacman-3 0.9s linear infinite;
}
.lds-pacman > div:nth-child(1) div:nth-child(1) {
  -webkit-animation-delay: -0.603s;
  animation-delay: -0.603s;
}
.lds-pacman > div:nth-child(1) div:nth-child(2) {
  -webkit-animation-delay: -0.297s;
  animation-delay: -0.297s;
}
.lds-pacman > div:nth-child(1) div:nth-child(3) {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
.lds-pacman {
  width: 200px !important;
  height: 200px !important;
  -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
  transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
}
</style>
